import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import api from '../../service/api';
import EtapaFonteAusente from './EtapaFonteAusente';
import '../../css/Vo2.css';
import '../../css/style.css';
import { HelpCircle } from "lucide-react";
import Indicador from '../../images/indicador.png';
import IconEsteira from '../../images/treadmill-w.png';
import IconBicicleta from '../../images/gym-w.png';
import IconPista from '../../images/training-w.png';
import IconBanco from '../../images/testeEmBanco.png';
import { formatarNumero } from '../../utils/formato';


function Vo2({ setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {
  // Navegação entre etapas
  const [etapa, setEtapa] = useState(1);
  const totalEtapas = 3;
  const porcentagemConclusao = (etapa / totalEtapas) * 100;

  const avancarEtapa = () => {
    setEtapa(etapa + 1);
  };

  const retrocederEtapa = () => {
    if (etapa > 1) {
      setEtapa(etapa - 1);
    }
  };

  // Popup de informações
  const [showInfo, setShowInfo] = useState(false);

  const [showInfoProcedimento, setShowInfoProcedimento] = useState("");

  // Modal para próxima etapa
  const [isNextModal, setIsNextModal] = useState(false);
  const openNextModal = () => {
    setIsNextModal(true);
  };
  const closeNextModal = () => {
    setIsNextModal(false);
  };

  // -------- Variaveis -------------
  //SALVAR E BUSCAR NO BD - LEVI 1/2
  const [metodoAtual, setMetodoAtual] = useState('');

  const [vo2, setVo2] = useState(0);

  const [vo2Preditivo, setVo2Preditivo] = useState(0);
  const [fcmax, setFCmax] = useState(0);
  const [fcRepouso, setFCrepouso] = useState(0);
  const [fcHRss, setFCHRss] = useState(0);
  const [fcmaxEstimada, setFCmaxEstimada] = useState(0);
  const [velocidade, setVelocidade] = useState(0);

  const [fcPrimeiroLimiar, setFcPrimeiroLimiar] = useState('');
  const [velocidadePrimeiroLimiar, setVelocidadePrimeiroLimiar] = useState('');

  const [fcSegundoLimiar, setFcSegundoLimiar] = useState('');
  const [velocidadeSegundoLimiar, setVelocidadeSegundoLimiar] = useState('');
  const [fcPicoPrimeiroLimiarmax, setFcPicoPrimeiroLimiar] = useState('');
  const [fcPicoSegundoLimiarmax, setFcPicoSegundoLimiar] = useState('');
  const [vlv1, setVlv1] = useState(0);
  const [vlv2, setVlv2] = useState(0);
  const [watts, setWatts] = useState(0);
  
  const [potencia, setPotencia] = useState(0);

  const [metodo, setMetodo] = useState('');
  const [tipoTeste, setTipoTeste] = useState('');

  const [tempo, setTempo] = useState('');
  const [distancia, setDistancia] = useState('');
  // FIM DO SALVAR E BUSCAR 1/2

  // const [vo2Previsto, setVo2Previsto] = useState(0);
  // const [estagioPrimeiroLimiar, setEstagioPrimeiroLimiar] = useState('');
  // const [estagioSegundoLimiar, setEstagioSegundoLimiar] = useState('');
  // const [met, setMet] = useState(0);
  // const [distDegraus, setDistDegraus] = useState(0);
  // const [tempoDegraus, setTempoDegraus] = useState(0);

  const [perfil, setPerfil] = useState("homensEMulheresAdultos");

  // Dados propagados: peso/idade/sexo/IMC vêm de evaluationData.antropometria;
  // percGordura vem de evaluationData.composicaoCorporal.percentualGordura.
  const [peso, setPeso] = useState('');
  const [idade, setIdade] = useState('');
  const [sexo, setSexo] = useState('');
  const [IMC, setIMC] = useState('');
  const [percGordura, setPercGordura] = useState('');

  // Tabela VO2 Geral - Mulheres
  const tabelaVo2GeralMulheres = {
    "25-": {
      "Muito baixo": { min: 0, max: 28 },
      "Baixo": { min: 28, max: 32 },
      "Insatisfatório": { min: 32, max: 37 },
      "Regular": { min: 37, max: 41 },
      "Bom": { min: 41, max: 46 },
      "Muito bom": { min: 46, max: 56 },
      "Excelente": { min: 56, max: 150 }
    },
    "26-35": {
      "Muito baixo": { min: 0, max: 26 },
      "Baixo": { min: 26, max: 30 },
      "Insatisfatório": { min: 30, max: 34 },
      "Regular": { min: 34, max: 38 },
      "Bom": { min: 38, max: 44 },
      "Muito bom": { min: 44, max: 52 },
      "Excelente": { min: 52, max: 150 }
    },
    "36-45": {
      "Muito baixo": { min: 0, max: 22 },
      "Baixo": { min: 22, max: 26 },
      "Insatisfatório": { min: 26, max: 30 },
      "Regular": { min: 30, max: 33 },
      "Bom": { min: 33, max: 37 },
      "Muito bom": { min: 37, max: 45 },
      "Excelente": { min: 45, max: 150 }
    },
    "46-55": {
      "Muito baixo": { min: 0, max: 20 },
      "Baixo": { min: 20, max: 24 },
      "Insatisfatório": { min: 24, max: 27 },
      "Regular": { min: 27, max: 30 },
      "Bom": { min: 30, max: 33 },
      "Muito bom": { min: 33, max: 40 },
      "Excelente": { min: 40, max: 150 }
    },
    "56-65": {
      "Muito baixo": { min: 0, max: 18 },
      "Baixo": { min: 18, max: 21 },
      "Insatisfatório": { min: 21, max: 24 },
      "Regular": { min: 24, max: 27 },
      "Bom": { min: 27, max: 31 },
      "Muito bom": { min: 31, max: 37 },
      "Excelente": { min: 37, max: 150 }
    },
    "65+": {
      "Muito baixo": { min: 0, max: 17 },
      "Baixo": { min: 17, max: 18 },
      "Insatisfatório": { min: 18, max: 22 },
      "Regular": { min: 22, max: 24 },
      "Bom": { min: 24, max: 27 },
      "Muito bom": { min: 27, max: 32 },
      "Excelente": { min: 32, max: 150 }
    }
  };

  // Tabela VO2 Geral - Homens
  const tabelaVo2GeralHomens = {
    "25-": {
      "Muito baixo": { min: 0, max: 30 },
      "Baixo": { min: 30, max: 36 },
      "Insatisfatório": { min: 36, max: 41 },
      "Regular": { min: 41, max: 46 },
      "Bom": { min: 46, max: 51 },
      "Muito bom": { min: 51, max: 60 },
      "Excelente": { min: 60, max: 150 }
    },
    "26-35": {
      "Muito baixo": { min: 0, max: 30 },
      "Baixo": { min: 30, max: 34 },
      "Insatisfatório": { min: 34, max: 39 },
      "Regular": { min: 39, max: 42 },
      "Bom": { min: 42, max: 48 },
      "Muito bom": { min: 48, max: 56 },
      "Excelente": { min: 56, max: 150 }
    },
    "36-45": {
      "Muito baixo": { min: 0, max: 26 },
      "Baixo": { min: 26, max: 30 },
      "Insatisfatório": { min: 30, max: 34 },
      "Regular": { min: 34, max: 38 },
      "Bom": { min: 38, max: 42 },
      "Muito bom": { min: 42, max: 51 },
      "Excelente": { min: 51, max: 150 }
    },
    "46-55": {
      "Muito baixo": { min: 0, max: 25 },
      "Baixo": { min: 25, max: 28 },
      "Insatisfatório": { min: 28, max: 31 },
      "Regular": { min: 31, max: 35 },
      "Bom": { min: 35, max: 38 },
      "Muito bom": { min: 38, max: 45 },
      "Excelente": { min: 45, max: 150 }
    },
    "56-65": {
      "Muito baixo": { min: 0, max: 22 },
      "Baixo": { min: 22, max: 25 },
      "Insatisfatório": { min: 25, max: 29 },
      "Regular": { min: 29, max: 31 },
      "Bom": { min: 31, max: 35 },
      "Muito bom": { min: 35, max: 41 },
      "Excelente": { min: 41, max: 150 }
    },
    "65+": {
      "Muito baixo": { min: 0, max: 20 },
      "Baixo": { min: 20, max: 21 },
      "Insatisfatório": { min: 21, max: 25 },
      "Regular": { min: 25, max: 28 },
      "Bom": { min: 28, max: 31 },
      "Muito bom": { min: 31, max: 37 },
      "Excelente": { min: 37, max: 150 }
    }
  };

  const resultadoVo2Geral = () => {
    let faixaEtaria;
    if (idade <= 25) faixaEtaria = "25-";
    else if (idade >= 26 && idade <= 35) faixaEtaria = "26-35";
    else if (idade >= 36 && idade <= 45) faixaEtaria = "36-45";
    else if (idade >= 46 && idade <= 55) faixaEtaria = "46-55";
    else if (idade >= 56 && idade <= 65) faixaEtaria = "56-65";
    else faixaEtaria = "65+";
  
    let faixa;
    if (sexo === "Masculino") {
      faixa = tabelaVo2GeralHomens[faixaEtaria];
    } else {
      faixa = tabelaVo2GeralMulheres[faixaEtaria];
    }
  
    for (const categoria in faixa) {
      const { min, max } = faixa[categoria];
      if (vo2 >= min && vo2 < max) {
        return categoria;
      }
    }
  
    return "Fora do alcance";
  };

  // Para Cooper
  const tabelaVo2CooperHomem = {
    "13-19": {
      "Muito fraco": { min: 0, max: 2090 },
      "Fraco": { min: 2090, max: 2200 },
      "Aceitável": { min: 2200, max: 2510 },
      "Muito bom": { min: 2510, max: 2770 },
      "Excelente": { min: 2770, max: 8000 }
    },
    "20-29": {
      "Muito fraco": { min: 0, max: 1960 },
      "Fraco": { min: 1960, max: 2110 },
      "Aceitável": { min: 2110, max: 2400 },
      "Muito bom": { min: 2400, max: 2640 },
      "Excelente": { min: 2640, max: 8000 }
    },
    "30-39": {
      "Muito fraco": { min: 0, max: 1900 },
      "Fraco": { min: 1900, max: 2090 },
      "Aceitável": { min: 2090, max: 2400 },
      "Muito bom": { min: 2400, max: 2510 },
      "Excelente": { min: 2510, max: 8000 }
    },
    "40-49": {
      "Muito fraco": { min: 0, max: 1830 },
      "Fraco": { min: 1830, max: 1990 },
      "Aceitável": { min: 1990, max: 2240 },
      "Muito bom": { min: 2240, max: 2460 },
      "Excelente": { min: 2460, max: 8000 }
    },
    "50-59": {
      "Muito fraco": { min: 0, max: 1660 },
      "Fraco": { min: 1660, max: 1870 },
      "Aceitável": { min: 1870, max: 2090 },
      "Muito bom": { min: 2090, max: 2320 },
      "Excelente": { min: 2320, max: 8000 }
    },
    "60+": {
      "Muito fraco": { min: 0, max: 1400 },
      "Fraco": { min: 1400, max: 1640 },
      "Aceitável": { min: 1640, max: 1930 },
      "Muito bom": { min: 1930, max: 2120 },
      "Excelente": { min: 2120, max: 8000 }
    }
  };

  const tabelaVo2CooperMulher = {
    "13-19": {
      "Muito fraco": { min: 0, max: 1600 },
      "Fraco": { min: 1600, max: 1900 },
      "Aceitável": { min: 1900, max: 2080 },
      "Muito bom": { min: 2080, max: 2300 },
      "Excelente": { min: 2300, max: 8000 }
    },
    "20-29": {
      "Muito fraco": { min: 0, max: 1550 },
      "Fraco": { min: 1550, max: 1790 },
      "Aceitável": { min: 1790, max: 1970 },
      "Muito bom": { min: 1970, max: 2160 },
      "Excelente": { min: 2160, max: 8000 }
    },
    "30-39": {
      "Muito fraco": { min: 0, max: 1510 },
      "Fraco": { min: 1510, max: 1690 },
      "Aceitável": { min: 1690, max: 1960 },
      "Muito bom": { min: 1960, max: 2080 },
      "Excelente": { min: 2080, max: 8000 }
    },
    "40-49": {
      "Muito fraco": { min: 0, max: 1420 },
      "Fraco": { min: 1420, max: 1580 },
      "Aceitável": { min: 1580, max: 1790 },
      "Muito bom": { min: 1790, max: 2000 },
      "Excelente": { min: 2000, max: 8000 }
    },
    "50-59": {
      "Muito fraco": { min: 0, max: 1350 },
      "Fraco": { min: 1350, max: 1500 },
      "Aceitável": { min: 1500, max: 1690 },
      "Muito bom": { min: 1690, max: 1900 },
      "Excelente": { min: 1900, max: 8000 }
    },
    "60+": {
      "Muito fraco": { min: 0, max: 1260 },
      "Fraco": { min: 1260, max: 1390 },
      "Aceitável": { min: 1390, max: 1590 },
      "Muito bom": { min: 1590, max: 1750 },
      "Excelente": { min: 1750, max: 8000 }
    }
  };

  // -------- Geração grafico de barras ---------
  const coresFaixasPadrao = {
    "Regular": "#b3e714",
    "Bom": "#32CD32",
    "Muito bom": "#00BFFF",
    "Excelente": "#4B0082",
    "Muito baixo": "#d70909",
    "Baixo": "#ff5e00",
    "Insatisfatório": "#FFD700",
    "Regular": "#b3e714",
    "Bom": "#32CD32",
    "Muito bom": "#00BFFF",
    "Excelente": "#4B0082",
  };

  const coresFaixasCooper = {
    "Muito fraco": "#d70909",
    "Fraco": "#ff5e00",
    "Aceitável": "#FFD700",
    "Muito bom": "#00BFFF",
    "Excelente": "#32CD32",
  };

  // Função utilitária para encontrar o intervalo correto baseado na idade
  const encontrarIntervaloIdade = (idade, intervalos) => {
    for (const faixa of Object.keys(intervalos)) {
      if (faixa.includes("+")) {
        const min = parseInt(faixa);
        if (idade >= min) return faixa;
      } else if (faixa.endsWith("-")) {
        // Chave tipo "25-" = idade máxima (25 anos ou menos)
        const max = parseInt(faixa);
        if (idade <= max) return faixa;
      } else if (faixa.includes("-")) {
        const [min, max] = faixa.split("-").map(Number);
        if (idade >= min && idade <= max) return faixa;
      }
    }
    return null; // se não encontrou
  };

  // Função principal para converter a tabela no formato esperado
  const obterFaixasVO2Formatadas = () => {
    let tabela = null;
    let cores = null;

    if (metodo === "cooper") {
      cores = coresFaixasCooper;
      tabela =
        sexo === "Masculino" ? tabelaVo2CooperHomem : tabelaVo2CooperMulher;
    } else {
      cores = coresFaixasPadrao;
      tabela =
        sexo === "Masculino" ? tabelaVo2GeralHomens : tabelaVo2GeralMulheres;
    }

    const faixaIdade = encontrarIntervaloIdade(idade, tabela);
    if (!faixaIdade || !tabela[faixaIdade]) return [];

    return Object.entries(tabela[faixaIdade]).map(([name, { min, max }]) => ({
      name,
      range: [min, max === Infinity ? max : parseFloat(formatarNumero(max, 1))],
      color: cores[name] || "#999",
    }));
  };

  // Cria o gráfico de barra com o indicador
  const GraficoBarraComIndicador = ({
    valor,
    faixas,
    largura = 340,
    altura = 25,
    corIndicador = "#fff",
    mostrarValor = false,
  }) => {
    const larguraSegmento = largura / faixas.length;
  
    // Encontra a faixa correspondente ao valor
    const faixaIndex = faixas.findIndex(
      (faixa) => valor >= faixa.range[0] && valor <= faixa.range[1]
    );
  
    let posicaoSeta = 0;
  
    if (faixaIndex !== -1) {
      const faixa = faixas[faixaIndex];
      const [min, max] = faixa.range;
      const percentualNaFaixa = (valor - min) / (max - min); // valor entre 0 e 1
  
      posicaoSeta = faixaIndex * larguraSegmento + percentualNaFaixa * larguraSegmento;
    }
  
    return (
      <div style={{ position: "relative", marginTop: "0px" }}>
        {/* Indicador (seta) */}
        <div
          style={{
            position: "absolute",
            left: `${posicaoSeta}px`,
            top: "10px",
            transform: "translateX(-50%) translateY(-14px)",
            fontSize: "20px",
            color: corIndicador,
            whiteSpace: "nowrap",
          }}
        >
          <img className="indicador-img" src={Indicador} alt="▲" />
          {mostrarValor && formatarNumero(valor, 1)}
        </div>
  
        {/* Barra segmentada com faixas de largura igual ▲ <img className="arrow-icon" src={LeviIcon} alt="corpo-humano" />*/}
        <div
          style={{
            display: "flex",
            height: `${altura}px`,
            width: `${largura}px`,
            overflow: "hidden",
            boxShadow: "0 0 4px rgba(0,0,0,0.1)",
          }}
        >
          {faixas.map((faixa, index) => {
            const borderRadiusStyle = {
              borderTopLeftRadius: index === 0 ? "2px" : "0px",
              borderBottomLeftRadius: index === 0 ? "2px" : "0px",
              borderTopRightRadius: index === faixas.length - 1 ? "2px" : "0px",
              borderBottomRightRadius: index === faixas.length - 1 ? "2px" : "0px",
            };
  
            return (
              <div
                key={index}
                style={{
                  width: `${larguraSegmento}px`,
                  backgroundColor: faixa.color,
                  ...borderRadiusStyle,
                }}
                title={`${faixa.name} (${faixa.range[0]} - ${faixa.range[1]})`}
              />
            );
          })}
        </div>
      </div>
    );
  };

  // Encontra as faixas mais gerais de classificação pra exibir nos resultados
  function encontrarFaixa(valor, faixas) {
    return faixas.find((faixa) =>
      valor >= faixa.range[0] && valor <= faixa.range[1]
    );
  }

  const faixasVO2calculadas = obterFaixasVO2Formatadas();

  console.log(faixasVO2calculadas);

  //Arrays com os dados de FC e PSE
  const [fcValores, setFcValores] = useState([]);
  const [pseValores, setPseValores] = useState([]);

  //Se eu entrar com o tempo, algumas funçoes são chamadas
  useEffect(() => {
    calculaFCmaxEstimada();
    calculaVo2MaxPrevistoPreditivo();
    calculaVo2Geral();
  }, [fcHRss, tempo, perfil, distancia, fcmax, fcRepouso, velocidade, watts, etapa]);

  useEffect(() => {
    getMaxFC();
    calcularLimiares();
    porcentagemFcPico();
  }, [fcValores]);

  //Salva e atualiza os valores num vetor de estados
  const atualizaFc = (indice, valor) => {
    setFcValores((prevFc) => {
      const novosValores = [...prevFc];
      novosValores[indice] = valor;
      return novosValores;
    });
  };
  
  const atualizaPse = (indice, valor) => {
    setPseValores((prevPse) => {
      const novosValores = [...prevPse];
      novosValores[indice] = valor;
      return novosValores;
    });
  };

  //Chama a função de acordo com o protocolo escolhido
  const calculaVo2Geral = () => {
    if(metodo === 'bruce'){
      calculaBruce();
    }
    else if(metodo === 'balke'){
      calculaBalke();
    }
    else if(metodo === 'ellestad'){
      calculaEllestad();
    }
    else if(metodo === 'cooper'){
      calculaCooper();
    }
    else if(metodo === 'rockport'){
      calculaRockport();
    }
    else if(metodo === 'ukk'){
      calculaUkk();
    }
    else if(metodo === 'coconi'){
      calculaCoconi();
    }
    else if(metodo === 'ventilatorio'){
      calculaVentilatorio();
    }
    else if(metodo === 'astrand'){
      calculaAstrand();
    }
    else if(metodo === 'astrand8min'){
      calculaAstrand8min();
    }
    else if(metodo === 'fox'){
      calculaFox();
    }
    else if(metodo === 'banco'){
      calculaBanco();
    }
    else if(metodo === 'bruceBic'){
      calculaBruceBic();
    }
    else if(metodo === 'astrandBic'){
      calculaAstrandBic();
    }
    else if(metodo === 'margaria'){
      calculaMargaria();
    }
  }

  // Velocidades para coletar com os limiares
  let velocidadesCoconi = [
    '5 km/h',  '5 km/h',  '5 km/h',
    '6 km/h',  '7 km/h',  '8 km/h',
    '9 km/h',  '10 km/h', '11 km/h',
    '12 km/h', '13 km/h', '14 km/h',
    '15 km/h', '16 km/h', '17 km/h',
    '18 km/h', '19 km/h', '20 km/h'
  ];

  let velocidadesIncremental = [
    '60 RPM', '60 RPM', '60 RPM',
    '60 RPM', '60 RPM', '60 RPM',
    '60 RPM', '60 RPM', '60 RPM',
    '60 RPM', '60 RPM', '60 RPM',
    '60 RPM', '60 RPM', '60 RPM'
  ];

  //Calcular limiares
  // Regra: o 1º limiar é o maior salto entre coletas consecutivas de FC e o 2º limiar é o segundo
  // maior salto, apresentados em ordem cronológica. A FC e a velocidade exibidas são as do estágio
  // em que o pico ocorreu (o estágio logo após o salto). Coletas em branco são ignoradas e empates
  // nunca apontam para o mesmo estágio duas vezes.
  const calcularLimiares = () => {
    const limpar = () => {
      setFcPrimeiroLimiar('');
      setFcSegundoLimiar('');
      setVelocidadePrimeiroLimiar('');
      setVelocidadeSegundoLimiar('');
    };

    const valores = fcValores.map((x) => Number(x));
    const saltos = [];
    for (let i = 0; i < valores.length - 1; i++) {
      const atual = valores[i];
      const proximo = valores[i + 1];
      if (!Number.isFinite(atual) || !Number.isFinite(proximo) || atual <= 0 || proximo <= 0) continue;
      saltos.push({ estagio: i + 1, salto: proximo - atual });
    }

    if (saltos.length < 2) {
      limpar();
      return;
    }

    const maiores = [...saltos].sort((a, b) => b.salto - a.salto).slice(0, 2);
    const [primeiro, segundo] = maiores.sort((a, b) => a.estagio - b.estagio);
    const velocidades = metodo === 'coconi' ? velocidadesCoconi : velocidadesIncremental;

    setFcPrimeiroLimiar(valores[primeiro.estagio]);
    setFcSegundoLimiar(valores[segundo.estagio]);
    setVelocidadePrimeiroLimiar(velocidades[primeiro.estagio] ?? '');
    setVelocidadeSegundoLimiar(velocidades[segundo.estagio] ?? '');
  };

  const calculaFCmaxEstimada = () => {
    let FC;
    FC = 208 - (idade * 0.7);
    setFCmaxEstimada(formatarNumero(FC, 0));
  }

  const getMaxFC = () => {
    // Filtra os valores válidos (não vazios e numéricos)
    const validFCValues = fcValores.filter(value => !isNaN(parseFloat(value)));
  
    setFCmax(validFCValues.length > 0 ? Math.max(...validFCValues) : '');
  };

  const calculaVo2MaxPrevistoPreditivo = () => {
    let voPrevisto, voPreditivo;
    if(perfil == 'Adulto'){
      voPrevisto = 66.1 - 0.44 * idade;
    }
    else{
      voPrevisto = 96.1 - 0.48 * idade;
    }

    voPreditivo = 57.5 - 0.31 * (idade) - 0.37 * (percGordura);

    //setVo2Previsto(formatarNumero(voPrevisto, 1));
    setVo2Preditivo(formatarNumero(voPreditivo, 1));
  }

  
  // Para Cooper
  const calculaCategoriaVo2Distancia = () => {
    let faixaEtaria;
    if (idade >= 13 && idade <= 19) faixaEtaria = "13-19";
    else if (idade >= 20 && idade <= 29) faixaEtaria = "20-29";
    else if (idade >= 30 && idade <= 39) faixaEtaria = "30-39";
    else if (idade >= 40 && idade <= 49) faixaEtaria = "40-49";
    else if (idade >= 50 && idade <= 59) faixaEtaria = "50-59";
    else faixaEtaria = "60+";
    
    let faixa;

    if(sexo == 'Masculino'){
      faixa = tabelaVo2CooperHomem[faixaEtaria];
      console.log(faixa);
    }
    else{
      faixa = tabelaVo2CooperMulher[faixaEtaria];
    }

    for (const categoria in faixa) {
      const { min, max } = faixa[categoria];
      if (distancia >= min && distancia < max) {
        return categoria;
      }
    }
  
    return "Fora do alcance";
  };

  const calculaDif = (a, b) => {
    return formatarNumero((Math.abs(a - b)), 1);
  }

  const defineNivel = (a, b) => {
    if(a > b){
      return 'abaixo';
    }
    else{
      return 'acima';
    }
  }

  // --------------- Calculos dos testes ------------------

  //Teste máximo de Bruce para esteira
  const calculaBruce = () => {
    let Vo2Max;
    if(sexo == 'Masculino'){
      Vo2Max = 14.76 - (1.379 * tempo) + (0.451 * tempo * tempo) - (0.012 * tempo * tempo * tempo);
    }
    else{
      Vo2Max = 4.38 * (tempo) - 3.9;
    }
    setVo2(formatarNumero(Vo2Max, 1));
  }

  //Teste máximo de Balke para esteira
  const calculaBalke = () => {
    let Vo2Max;
    if(sexo == 'Masculino'){
      Vo2Max = 1.444 * tempo + 14.99;
    }
    else{
      Vo2Max = 1.38 * tempo + 5.22;
    }
    setVo2(formatarNumero(Vo2Max, 1));
  }

  //Teste máximo de Ellestad para esteira
  const calculaEllestad = () => {
    let Vo2Max;
    if(perfil == 'ativo'){
      if(sexo == 'Masculino'){
        Vo2Max = 8.33 + (2.94 * tempo);
      }
      else{
        Vo2Max = 8.05 + (2.74 * tempo);
      }
    }
    else{
      Vo2Max = 4.46 + (3.933 * tempo);
    }
    setVo2(formatarNumero(Vo2Max, 1));
  }

  //Teste de Cooper 12min (protocolo em pista)
  const calculaCooper = () => {
    let Vo2Max;
    Vo2Max = (distancia - 504.9) / 44.73;
    setVo2(formatarNumero(Vo2Max, 1));
  }

  //Teste de 1 milha – (Rockport - 1.600mts)
  const calculaRockport = () => {
    let Vo2Max;
    if(sexo == 'Masculino'){                     
      Vo2Max = 132.853 - (0.0769 * peso / 0.4536) - (0.3877 * idade) + (6.315) - (3.2649 * tempo) - (0.1565 * fcmax);
    }
    else{
      Vo2Max = 132.853 - (0.0769 * peso / 0.4536) - (0.3877 * idade) - (3.2649 * tempo) - (0.1565 * fcmax);
    }
    setVo2(formatarNumero(Vo2Max, 1));
  }

  //Teste de UKK (2.000mts)
  const calculaUkk = () => {
    let Vo2Max;
    if(sexo == 'Masculino'){
      //Vo2max = (184 –(4,65 x tempo) – (0,22 x FC) – (0,26 x idade) – (1,05 x IMC)
      Vo2Max = 184.9 - (4.65 * tempo) - (0.22 * fcmax) - (0.26 * idade) - (1.05 * IMC);
    }
    else{
      Vo2Max = 116.2 - (2.98 * tempo) - (0.11 * fcmax) - (0.14 * idade) - (0.39 * IMC);
    }
    setVo2(formatarNumero(Vo2Max, 1));
  }

  //Teste de Coconi
  const calculaCoconi = () => {
    let Vo2Max, indiceFC, mets;

    indiceFC = fcmax / fcRepouso;
    mets = 6 * indiceFC;
    Vo2Max = 3.5 * mets;

    setVo2(formatarNumero(Vo2Max, 1));
  }

  const porcentagemFcPico = () =>{
    let porcPrimeiro, porcSegundo;

    porcPrimeiro = fcPrimeiroLimiar / fcmax * 100;
    porcSegundo = fcSegundoLimiar / fcmax * 100;

    setFcPicoPrimeiroLimiar(formatarNumero(porcPrimeiro, 0));
    setFcPicoSegundoLimiar(formatarNumero(porcSegundo, 0));
  }

  //Teste incremental para estimativa dos limiares ventilatórios (teste em esteira)
  const calculaVentilatorio = () => {
    let auxVlv1, auxVlv2, Vo2Max, indiceFC, mets;

    auxVlv2 = 2.51 + (0.61 * velocidade);
    auxVlv1 = 0.8 * auxVlv2;

    indiceFC = fcmax / fcRepouso;
    mets = 6 * indiceFC;
    Vo2Max = 3.5 * mets;

    setVo2(formatarNumero(Vo2Max, 1));

    setVlv1(formatarNumero(auxVlv1, 1));
    setVlv2(formatarNumero(auxVlv2, 1));
  }

  //Teste máximo de Astrand e Rodahhl - bicicleta
  const calculaAstrand = () => {
    let Vo2Max, Vo2MaxLMin;

    let carga = watts * 6.12;

    if (sexo === 'Masculino') {
      Vo2MaxLMin = (0.00212 * carga + 0.299) / (0.769 * fcHRss - 48.5) * 100;
    } else {
      Vo2MaxLMin = (0.00193 * carga + 0.326)  / (0.769 * fcHRss - 56.1) * 100 ;
    }

    Vo2Max = (Vo2MaxLMin * 1000) / peso;

    // Fatores de correção por idade
    const fatores = {
      15: 1.10,
      25: 1.00,
      35: 0.87,
      40: 0.83,
      45: 0.78,
      50: 0.75,
      55: 0.71,
      60: 0.68,
      65: 0.65,
    };

    // Busca o fator de correção mais próximo da idade (menor ou igual)
    const idades = Object.keys(fatores).map(Number).sort((a, b) => b - a);
    const fator = idades.find(i => idade >= i) ? fatores[idades.find(i => idade >= i)] : 1.00;

    // Aplica fator de correção
    const Vo2Corrigido = Vo2Max * fator;

    setVo2(formatarNumero(Vo2Corrigido, 1));
  };

  //Teste submáximo de Astrand 8 minutos - bicicleta
  const calculaAstrand8min = () => {
    // 1. Calcula o VO2Máx bruto em ml/min
    // Fórmula: (Watts × 12) + 300
    const vo2MlMin = (watts * 12) + 300;

    // 2. Converte para Litros por minuto (L/min)
    const vo2LMin = vo2MlMin / 1000;

    // 3. Converte para mililitros por quilograma por minuto (ml/kg/min)
    // Esta é a métrica mais comum para classificar o condicionamento
    let vo2MlKgMin = vo2MlMin / peso;

    // 4. Aplica o fator de correção de idade/classificação (classificaAstrand)
    const fator = classificaAstrand();
    vo2MlKgMin = vo2MlKgMin * fator;

    // Atualiza o estado com o valor final corrigido em ml/kg/min
    setVo2(formatarNumero(vo2MlKgMin, 2));
  }

  const classificaAstrand = () =>{
    let fatorAstrand;

    if (idade >= 15 && idade <= 20) fatorAstrand = "1.1";
    else if (idade >= 20 && idade <= 28) fatorAstrand = "1";
    else if (idade >= 28 && idade <= 35) fatorAstrand = "0.87";
    else if (idade >= 35 && idade <= 40) fatorAstrand = "0.83";
    else if (idade >= 40 && idade <= 45) fatorAstrand = "0.78";
    else if (idade >= 45 && idade <= 50) fatorAstrand = "0.75";
    else if (idade >= 50 && idade <= 55) fatorAstrand = "0.75";
    else if (idade >= 55 && idade <= 60) fatorAstrand = "0.68";
    else if (idade >= 60 && idade <= 65) fatorAstrand = "0.64";
    else fatorAstrand = "0.63";

    return fatorAstrand;
  }

  //Teste submáximo de Fox - bicicleta
  const calculaFox = () => {
    let Vo2MaxMl, Vo2Max;

    Vo2MaxMl = 6300 - 19.26 * (fcmax);

    Vo2Max = Vo2MaxMl / peso;

    setVo2(formatarNumero(Vo2Max, 1));
  }

  //Teste submáximo em banco (Katch e McArdle, 1984)
  const calculaBanco = () => {
    let Vo2Max;
    if(sexo == 'Masculino'){
      Vo2Max = 111.33 - (0.42 * fcmax);
    }
    else{
      Vo2Max = 65.81 - (0.1847 * fcmax);
    }
    setVo2(formatarNumero(Vo2Max, 1));
  }
  
  //Teste máximo de Bruce - bicicleta
  const calculaBruceBic = () => {
    let Vo2Max;
    
    if (sexo === 'Masculino') {
      Vo2Max = (10.51 * watts) + (6.35 * peso) - (10.49 * idade) + 519.3;
    } else {
      Vo2Max = (9.39 * watts) + (7.7 * peso) - (5.88 * idade) + 136.7;
    }
    
    setVo2(formatarNumero(Vo2Max, 1));
  }

  //Teste submáximo de Astrand-Rhyming (carga única) - bicicleta
  const calculaAstrandBic = () => {
    let Vo2Max, Vo2Sub, fator;

    // 1. Obtém o fator de correção por idade
    fator = classificaAstrand();

    // 2. Calcula o VO2 submáximo utilizando a fórmula corrigida (fator 100)
    // VO₂max (ml/kg/min) = [(Carga × 6) / Peso] × 100 / FC
    Vo2Sub = ((watts * 6) / peso) * (100 / fcmax);

    // 3. Aplica o fator de correção de idade para obter o VO2 Máximo real
    Vo2Max = Vo2Sub * fator;

    // 4. Atualiza o estado com 1 casa decimal (.toFixed(1)) conforme o seu padrão
    setVo2(formatarNumero(Vo2Max, 1));
  }

  //Teste de potência anaeróbia de Margaria e Kalamen
  const calculaMargaria = () => {
    let potAnab;

    //potAnab = peso * (distDegraus / 100) / tempoDegraus;

    setPotencia(formatarNumero(potAnab, 1));
  }

  // Zera os valores ao trocar de teste

  useEffect(() => {
    // Salvo o metodo atual quando troco de etapa
    setMetodoAtual(metodo);

    // Caso eu troque de teste
    if(metodo != metodoAtual){
      setFCmax(0);
      setVo2(0);
      setTempo(0);
      setDistancia(0);
      setFcValores([]);
    }

  }, [etapa]);

  useEffect(() => {
    // Propaga dados da Antropometria e da Composição Corporal (precedência: vo2 próprio sobrescreve abaixo).
    if (evaluationData?.antropometria) {
      const a = evaluationData.antropometria;
      if (a.peso !== undefined) setPeso(a.peso);
      if (a.idade !== undefined) setIdade(a.idade);
      if (a.sexo) setSexo(a.sexo);
      if (a.imc !== undefined) setIMC(a.imc);
    }
    if (evaluationData?.composicaoCorporal?.percentualGordura !== undefined) {
      setPercGordura(evaluationData.composicaoCorporal.percentualGordura);
    }

    if (evaluationData?.vo2) {
      const v = evaluationData.vo2;
      if (v.metodoAtual) setMetodoAtual(v.metodoAtual);
      if (v.vo2) setVo2(v.vo2);
      if (v.vo2Preditivo) setVo2Preditivo(v.vo2Preditivo);
      if (v.fcmax) setFCmax(v.fcmax);
      if (v.fcRepouso) setFCrepouso(v.fcRepouso);
      if (v.fcHRss) setFCHRss(v.fcHRss);
      if (v.fcmaxEstimada) setFCmaxEstimada(v.fcmaxEstimada);
      if (v.velocidade) setVelocidade(v.velocidade);
      if (v.fcPrimeiroLimiar) setFcPrimeiroLimiar(v.fcPrimeiroLimiar);
      if (v.velocidadePrimeiroLimiar) setVelocidadePrimeiroLimiar(v.velocidadePrimeiroLimiar);
      if (v.fcSegundoLimiar) setFcSegundoLimiar(v.fcSegundoLimiar);
      if (v.velocidadeSegundoLimiar) setVelocidadeSegundoLimiar(v.velocidadeSegundoLimiar);
      if (v.fcPicoPrimeiroLimiarmax) setFcPicoPrimeiroLimiar(v.fcPicoPrimeiroLimiarmax);
      if (v.fcPicoSegundoLimiarmax) setFcPicoSegundoLimiar(v.fcPicoSegundoLimiarmax);
      if (v.vlv1) setVlv1(v.vlv1);
      if (v.vlv2) setVlv2(v.vlv2);
      if (v.watts) setWatts(v.watts);
      if (v.potencia) setPotencia(v.potencia);
      if (v.metodo) setMetodo(v.metodo);
      if (v.tipoTeste) setTipoTeste(v.tipoTeste);
      if (v.tempo) setTempo(v.tempo);
      if (v.distancia) setDistancia(v.distancia);
      // Tabela de coletas (FC/PSE por estágio): sem ela a tela do teste volta em branco.
      if (Array.isArray(v.fcValores)) setFcValores(v.fcValores.map((x) => (x === null ? undefined : x)));
      if (Array.isArray(v.pseValores)) setPseValores(v.pseValores.map((x) => (x === null ? undefined : x)));
    }
  }, [evaluationData]);

  const handleVo2Register = async () => {
    const payload = {
      vo2: {
        metodoAtual, vo2, vo2Preditivo,
        fcmax, fcRepouso, fcHRss, fcmaxEstimada, velocidade,
        fcPrimeiroLimiar, velocidadePrimeiroLimiar,
        fcSegundoLimiar, velocidadeSegundoLimiar,
        fcPicoPrimeiroLimiarmax, fcPicoSegundoLimiarmax,
        vlv1, vlv2, watts, potencia,
        metodo, tipoTeste, tempo, distancia,
        fcValores, pseValores
      },
      evaluationId
    };

    try {
      const response = await api.post(`/api/student/${aluno.id}/evaluation/vo2`, payload, { withCredentials: true });
      if (response.status === 200) {
        if (response.data.evaluationId && setEvaluationId) {
          if (!evaluationId) {
            if (!aluno.avaliacoesRealizadas) aluno.avaliacoesRealizadas = [];
            aluno.avaliacoesRealizadas.push({
              id: response.data.evaluationId,
              data: new Date().toISOString()
            });
          }
          setEvaluationId(response.data.evaluationId);
        }
        if (updateEvaluationData) {
          updateEvaluationData({ vo2: payload.vo2 });
        }
        openNextModal();
      }
    } catch (error) {
      console.error('Erro ao salvar VO2:', error);
    }
  };

  // Navegação provisória
  const toAntropometria = () => {
    setActiveTab("Antropometria");
  };

  // CAP-3: bloqueia se alguma das etapas-fonte (Antropometria, Composição Corporal) não foi preenchida.
  const antropometriaPresente = evaluationData?.antropometria?.peso !== undefined;
  const composicaoPresente = evaluationData?.composicaoCorporal?.percentualGordura !== undefined;
  if (!antropometriaPresente || !composicaoPresente) {
    return (
      <EtapaFonteAusente
        etapaAtual="VO2"
        etapasFontes={[
          { nome: 'Antropometria', tabKey: 'Antropometria', presente: antropometriaPresente },
          { nome: 'Composição Corporal', tabKey: 'Composicao Corporal', presente: composicaoPresente },
        ]}
        setActiveTab={setActiveTab}
      />
    );
  }

  return (
    <div className="avaliacao-container">
      <div className="avaliacao-content">
        {etapa === 1 && (
          <div className="questions-container">
            <div className="questions-left">
              <div className="question-item">
                <div className="question-title">Selecione o equipamento do teste</div>
                <div className="selecao-metodos-vo2">
                  <div className="selecao-metodos-vo2-col">
                    <button className="next-prev-button botao-teste-vo2" type="button" onClick={() => {setTipoTeste("Esteira"); setEtapa(2);}}>
                      <img src={IconEsteira} alt="Esteira" />
                      Testes em Esteira
                    </button>
                    <button className="next-prev-button botao-teste-vo2" type="button" onClick={() => {setTipoTeste("Bicicleta"); setEtapa(2);}}>
                      <img src={IconBicicleta} alt="Esteira" />
                      Testes em Bicicleta
                    </button>
                  </div>
                  <div className="selecao-metodos-vo2-col">
                    <button className="next-prev-button botao-teste-vo2" type="button" onClick={() => {setTipoTeste("Pista"); setEtapa(2);}}>
                      <img src={IconPista} alt="Esteira" />
                      Testes em Pista
                    </button>
                    <button className="next-prev-button botao-teste-vo2" type="button" onClick={() => {setTipoTeste("Banco"); setEtapa(2);}}>
                      <img src={IconBanco} alt="Esteira" />
                      Testes em Banco
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="questions-right">
              <div className="question-item">
                <div className="question-title">Contraindicações para os testes de esforço</div>
                <div className="resultado-referencia-vo2 referencia-largura-total">
                  <p className="vo2-info-title">Contraindicações absolutas</p>
                  <p className="vo2-info-content pad-top-10">1- Infarto agudo do miocárdio recente;</p>
                  <p className="vo2-info-content">2- Angina instável;</p>
                  <p className="vo2-info-content">3- Arritmia atrial não controlada;</p>
                  <p className="vo2-info-content">4- Insuficiência cardíaca congestiva;</p>
                  <p className="vo2-info-content">5- Infecção aguda;</p>
                  <p className="vo2-info-content">6- Bloqueio auriculoventricular de terceiro grau;</p>
                  <p className="vo2-info-content">7- Angústia emocional significativa;</p>
                  <p className="vo2-info-content">8- Embolia pulmonar ou sistêmica recente.</p>
                </div>
                <div className="resultado-referencia-vo2 referencia-largura-total">
                  <p className="vo2-info-title">Contraindicações relativas</p>
                  <p className="vo2-info-content pad-top-10">1- Pressão arterial diastólica de repouso acima de 110 mmHg ou pressão sistólica de repouso acima de 180 mmHg;</p>
                  <p className="vo2-info-content">2- Marca-passo artificial de frequência fixa;</p>
                  <p className="vo2-info-content">3- Doenças metabólicas não controladas;</p>
                  <p className="vo2-info-content">4- Qualquer doença sistêmica grave;</p>
                  <p className="vo2-info-content">5- Doenças neuromusculares, musculoesqueléticas ou reumatóides que dificultem o exercício.</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {etapa === 2 && (
          <div className="questions-container">
            <div className="questions-left">
              {tipoTeste === 'Esteira' && (
                <div className="question-item">
                  <div className="question-title">Testes em Esteira</div>
                  <div className="selecao-testes-vo2-container pad-top-5">
                    <ul className="metodos-vo2-list">
                      <li className="" onClick={() => {setMetodo('bruce'); setEtapa(3);}}>Teste máximo de Bruce<p>Perfil: Ambos os sexos ativos ou sedentário</p></li>
                      <li className="" onClick={() => {setMetodo('balke'); setEtapa(3);}}>Teste submáximo de Balke e Ware<p>Perfil: Indivíduos saudáveis</p></li>
                      <li className="" onClick={() => {setMetodo('ellestad'); setEtapa(3);}}>Teste máximo de Ellestad<p>Perfil: Homens e mulheres (iniciantes, ativos, atletas)</p></li>
                      <li className="" onClick={() => {setMetodo('coconi'); setEtapa(3);}}>Teste de Coconi <p>Perfil: Homens e mulheres (iniciantes, ativos, atletas)</p></li>
                      <li className="" onClick={() => {setMetodo('ventilatorio'); setEtapa(3);}}>Teste incremental para estimativa dos limiares ventilatórios<p>Perfil: Homens e mulheres (iniciantes, ativos, atletas)</p></li>
                    </ul>
                  </div>
                </div>
              )}
              {tipoTeste === 'Bicicleta' && (
                <div className="question-item">
                  <div className="question-title">Testes em Bicicleta</div>
                  <div className="selecao-testes-vo2-container pad-top-5">
                    <ul className="metodos-vo2-list">
                      <li className="" onClick={() => {setMetodo('astrand'); setEtapa(3);}}>Teste máximo de Astrand e Rodahhl <p>Perfil: Homens e mulheres (iniciantes, ativos, atletas)</p></li>
                      <li className="" onClick={() => {setMetodo('astrand8min'); setEtapa(3);}}>Teste submáximo de Astrand 8 minutos <p>Perfil: Pessoas sedentárias com fatores de risco para doenças cardiovasculares; Iniciantes a partir de 12 anos</p></li>
                      <li className="" onClick={() => {setMetodo('fox'); setEtapa(3);}}>Teste submáximo de Fox <p>Perfil: Homens a partir de 19 anos</p></li>
                      <li className="" onClick={() => {setMetodo('bruceBic'); setEtapa(3);}}>Teste máximo de Bruce <p>Perfil: Homens e mulheres (iniciantes, ativos, atletas)</p></li>
                      <li className="" onClick={() => {setMetodo('astrandBic'); setEtapa(3);}}>Teste submáximo de Astrand-Rhyming (carga única) <p>Perfil: Homens e mulheres (iniciantes, ativos, atletas)</p></li>
                    </ul>
                  </div>
                </div>
              )}
              {tipoTeste === 'Pista' && (
                <div className="question-item">
                  <div className="question-title">Testes em Pista</div>
                  <div className="selecao-testes-vo2-container pad-top-5">
                    <ul className="metodos-vo2-list">
                      <li className="" onClick={() => {setMetodo('cooper'); setEtapa(3);}}>Teste de Cooper 12min<p>Perfil: Atletas e pessoas ativas fisicamente</p></li>
                      <li className="" onClick={() => {setMetodo('rockport'); setEtapa(3);}}>Teste de 1 milha - (Rockport - 1.600mts) <p>Perfil: Sedentários e obesos</p></li>
                      <li className="" onClick={() => {setMetodo('ukk'); setEtapa(3);}}>Teste de UKK (2.000mts) <p>Perfil: Sedentários e idosos</p></li>
                    </ul>
                  </div>
                </div>
              )}
              {tipoTeste === 'Banco' && (
                <div className="question-item">
                  <div className="question-title">Testes em Banco</div>
                  <div className="selecao-testes-vo2-container pad-top-5">
                    <ul className="metodos-vo2-list">
                      <li className="" onClick={() => {setMetodo('banco'); setEtapa(3);}}>Teste submáximo em banco (Katch e McArdle, 1972)<p>Perfil: Homens e mulheres (iniciantes, ativos, atletas)</p></li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {etapa === 3 && (
          <div className="questions-container">
            <div className="questions-left">
              {metodo === 'bruce' &&(
                <div>
                  <div className="question-title">Teste máximo de Bruce para esteira</div>
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <a
                      className="btt-vo2-procedimentos"
                      onMouseEnter={() => setShowInfoProcedimento(true)}
                      onMouseLeave={() => setShowInfoProcedimento(false)}
                    >
                      Procedimentos para realização do teste
                    </a>
                    {showInfoProcedimento && (
                      <div className="info-box-procedimentos">
                        <p>
                          <b>Objetivo: </b>
                          Avaliar a aptidão cardiorrespiratória por meio da estimativa do VO₂máx com esforço máximo progressivo.
                          <br/><br/>
                          <b>Procedimento: </b>
                          O teste é realizado em esteira e consiste em estágios de 3 minutos, com aumentos progressivos na velocidade e inclinação. O avaliado deve permanecer o maior tempo possível até a exaustão voluntária.
                          <br/><br/>
                          <b>Orientações:</b>
                            <br/>
                            •	Monitorar constantemente a frequência cardíaca e a percepção de esforço.<br/>
                            •	O teste deve ser interrompido caso o avaliado atinja exaustão, apresente sinais de intolerância ao exercício ou atinja 85-90% da FCmáx, conforme o objetivo.<br/>
                            •	Registrar o tempo total em minutos para uso na equação de estimativa do VO₂máx.
                        </p>
                      </div>
                    )}
                  </div>
                  <table className="tabela-geral-vo2">
                    <thead>
                      <tr>
                        <th>Estágio</th>
                        <th>Velocidade (km/h)</th>
                        <th>Inclinação</th>
                        <th>Minutos</th>
                        <th>FC</th>
                        <th>PSE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>2,7</td>
                        <td>10%</td>
                        <td>3</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceFC1"
                            placeholder={fcValores[0] || ''}
                            value={fcValores[0] || ''}
                            onChange={(e) => atualizaFc(0, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="brucePSE1"
                            placeholder={pseValores[0] || ''}
                            value={pseValores[0] || ''}
                            onChange={(e) => atualizaPse(0, e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>4,0</td>
                        <td>12%</td>
                        <td>3</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceFC2"
                            placeholder={fcValores[1] || ''}
                            value={fcValores[1] || ''}
                            onChange={(e) => atualizaFc(1, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="brucePSE2"
                            placeholder={pseValores[1] || ''}
                            value={pseValores[1] || ''}
                            onChange={(e) => atualizaPse(1, e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>5,4</td>
                        <td>14%</td>
                        <td>3</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceFC3"
                            placeholder={fcValores[2] || ''}
                            value={fcValores[2] || ''}
                            onChange={(e) => atualizaFc(2, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="brucePSE3"
                            placeholder={pseValores[2] || ''}
                            value={pseValores[2] || ''}
                            onChange={(e) => atualizaPse(2, e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>6,8</td>
                        <td>16%</td>
                        <td>3</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceFC4"
                            placeholder={fcValores[3] || ''}
                            value={fcValores[3] || ''}
                            onChange={(e) => atualizaFc(3, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="brucePSE4"
                            placeholder={pseValores[3] || ''}
                            value={pseValores[3] || ''}
                            onChange={(e) => atualizaPse(3, e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>8,0</td>
                        <td>18%</td>
                        <td>3</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceFC5"
                            placeholder={fcValores[4] || ''}
                            value={fcValores[4] || ''}
                            onChange={(e) => atualizaFc(4, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="brucePSE5"
                            placeholder={pseValores[4] || ''}
                            value={pseValores[4] || ''}
                            onChange={(e) => atualizaPse(4, e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>8,8</td>
                        <td>20%</td>
                        <td>3</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceFC6"
                            placeholder={fcValores[5] || ''}
                            value={fcValores[5] || ''}
                            onChange={(e) => atualizaFc(5, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="brucePSE6"
                            placeholder={pseValores[5] || ''}
                            value={pseValores[5] || ''}
                            onChange={(e) => atualizaPse(5, e.target.value)}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className='pad-top-20'>
                    <b className='entrada-tempo-outros'>Entre com o tempo: </b>
                    <input className="entrada-tabela-vo2" type="text" name="tempo" placeholder={tempo} value={tempo} onChange={e => setTempo(e.target.value)} />
                  </div>
                </div>
              )}
              {metodo === 'balke' &&(
                <div>
                  <div className="question-title">Teste submáximo de Balke e Ware em esteira</div>
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <a
                      className="btt-vo2-procedimentos"
                      onMouseEnter={() => setShowInfoProcedimento(true)}
                      onMouseLeave={() => setShowInfoProcedimento(false)}
                    >
                      Procedimentos para realização do teste
                    </a>
                    {showInfoProcedimento && (
                      <div className="info-box-procedimentos">
                        <p>
                          <b>Objetivo: </b>
                          Estimar o VO₂máx de forma segura, sem levar o avaliado ao esforço máximo, utilizando a resposta da frequência cardíaca ao exercício.
                          <br/><br/>
                          <b>Procedimento: </b>
                          O teste é realizado em esteira, com velocidade constante e aumento gradual da inclinação. O avaliado deve caminhar até atingir 85% da frequência cardíaca máxima estimada (208 – 0,7 × idade, fórmula de Tanaka — a mesma usada pelo sistema).
                          <br/><br/>
                          <b>Orientações:</b>
                          <br/>
                          • O avaliado deve manter a marcha contínua e confortável.<br/>
                          • Monitorar a frequência cardíaca minuto a minuto.<br/>
                          • Registrar o tempo total (em minutos) até o encerramento do teste para cálculo do VO₂máx.<br/>
                          • Ideal para populações iniciantes, idosos ou reabilitação cardiovascular.
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="horizontal-scroll-table">
                    <table className="tabela-geral-vo2">
                      <thead>
                        <tr>
                          <th>Estágio</th>
                          <th>Velocidade (km/h)</th>
                          <th>Inclinação</th>
                          <th>Minutos</th>
                          <th>FC</th>
                          <th>PSE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>0%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC1"
                              placeholder={fcValores[0] || ''}
                              value={fcValores[0] || ''}
                              onChange={(e) => atualizaFc(0, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE1"
                              placeholder={pseValores[0] || ''}
                              value={pseValores[0] || ''}
                              onChange={(e) => atualizaPse(0, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>2%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC2"
                              placeholder={fcValores[1] || ''}
                              value={fcValores[1] || ''}
                              onChange={(e) => atualizaFc(1, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE2"
                              placeholder={pseValores[1] || ''}
                              value={pseValores[1] || ''}
                              onChange={(e) => atualizaPse(1, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>3%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC3"
                              placeholder={fcValores[2] || ''}
                              value={fcValores[2] || ''}
                              onChange={(e) => atualizaFc(2, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE3"
                              placeholder={pseValores[2] || ''}
                              value={pseValores[2] || ''}
                              onChange={(e) => atualizaPse(2, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>4%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC4"
                              placeholder={fcValores[3] || ''}
                              value={fcValores[3] || ''}
                              onChange={(e) => atualizaFc(3, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE4"
                              placeholder={pseValores[3] || ''}
                              value={pseValores[3] || ''}
                              onChange={(e) => atualizaPse(3, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>5%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC5"
                              placeholder={fcValores[4] || ''}
                              value={fcValores[4] || ''}
                              onChange={(e) => atualizaFc(4, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE5"
                              placeholder={pseValores[4] || ''}
                              value={pseValores[4] || ''}
                              onChange={(e) => atualizaPse(4, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>6%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC6"
                              placeholder={fcValores[5] || ''}
                              value={fcValores[5] || ''}
                              onChange={(e) => atualizaFc(5, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE6"
                              placeholder={pseValores[5] || ''}
                              value={pseValores[5] || ''}
                              onChange={(e) => atualizaPse(5, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>7%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC6"
                              placeholder={fcValores[6] || ''}
                              value={fcValores[6] || ''}
                              onChange={(e) => atualizaFc(6, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE6"
                              placeholder={pseValores[6] || ''}
                              value={pseValores[6] || ''}
                              onChange={(e) => atualizaPse(6, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>8%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC6"
                              placeholder={fcValores[7] || ''}
                              value={fcValores[7] || ''}
                              onChange={(e) => atualizaFc(7, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE6"
                              placeholder={pseValores[7] || ''}
                              value={pseValores[7] || ''}
                              onChange={(e) => atualizaPse(7, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>9%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC6"
                              placeholder={fcValores[8] || ''}
                              value={fcValores[8] || ''}
                              onChange={(e) => atualizaFc(8, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE6"
                              placeholder={pseValores[8] || ''}
                              value={pseValores[8] || ''}
                              onChange={(e) => atualizaPse(8, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>10%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC6"
                              placeholder={fcValores[9] || ''}
                              value={fcValores[9] || ''}
                              onChange={(e) => atualizaFc(9, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE6"
                              placeholder={pseValores[9] || ''}
                              value={pseValores[9] || ''}
                              onChange={(e) => atualizaPse(9, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>11%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC6"
                              placeholder={fcValores[10] || ''}
                              value={fcValores[10] || ''}
                              onChange={(e) => atualizaFc(10, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE6"
                              placeholder={pseValores[10] || ''}
                              value={pseValores[10] || ''}
                              onChange={(e) => atualizaPse(10, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>{sexo === 'Masculino' ? "5,31" : "4,8"}</td>
                          <td>12%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkeFC6"
                              placeholder={fcValores[11] || ''}
                              value={fcValores[11] || ''}
                              onChange={(e) => atualizaFc(11, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="balkePSE6"
                              placeholder={pseValores[11] || ''}
                              value={pseValores[11] || ''}
                              onChange={(e) => atualizaPse(11, e.target.value)}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className='pad-top-20'>
                      <b className='entrada-tempo-outros'>Entre com o tempo: </b>
                      <input className="entrada-tabela-vo2" type="text" name="tempo" placeholder={tempo} value={tempo} onChange={e => setTempo(e.target.value)} />
                    </div>
                  </div>
                </div>
              )}
              {metodo === 'ellestad' &&(
                <div>
                <div className="question-title">Teste máximo de Ellestad em esteira</div>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <a
                    className="btt-vo2-procedimentos"
                    onMouseEnter={() => setShowInfoProcedimento(true)}
                    onMouseLeave={() => setShowInfoProcedimento(false)}
                  >
                    Procedimentos para realização do teste
                  </a>
                  {showInfoProcedimento && (
                    <div className="info-box-procedimentos">
                      <p>
                        <b>Objetivo: </b>
                        Avaliar a aptidão cardiorrespiratória por meio de um teste máximo progressivo em esteira.
                        <br/><br/>
                        <b>Procedimento: </b>
                        O teste é dividido em estágios de 3 e 2 minutos, com aumento progressivo da velocidade e inclinação. O avaliado deve manter o esforço até a exaustão voluntária.
                        <br/><br/>
                        <b>Orientações:</b>
                        <br/>
                        • O tempo total do teste (até a interrupção) é utilizado para estimar o VO₂máx.<br/>
                        • Deve ser interrompido em caso de sintomas adversos ou exaustão.
                      </p>
                    </div>
                  )}
                </div>
                <div className="horizontal-scroll-table">
                  <table className="tabela-geral-vo2">
                      <thead>
                        <tr>
                          <th>Estágio</th>
                          <th>Velocidade (km/h)</th>
                          <th>Inclinação</th>
                          <th>Minutos</th>
                          <th>FC</th>
                          <th>PSE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>2,7</td>
                          <td>10%</td>
                          <td>2</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadFC1"
                              placeholder={fcValores[0] || ''}
                              value={fcValores[0] || ''}
                              onChange={(e) => atualizaFc(0, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadPSE1"
                              placeholder={pseValores[0] || ''}
                              value={pseValores[0] || ''}
                              onChange={(e) => atualizaPse(0, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>4,8</td>
                          <td>10%</td>
                          <td>2</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadFC2"
                              placeholder={fcValores[1] || ''}
                              value={fcValores[1] || ''}
                              onChange={(e) => atualizaFc(1, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadPSE2"
                              placeholder={pseValores[1] || ''}
                              value={pseValores[1] || ''}
                              onChange={(e) => atualizaPse(1, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>6,4</td>
                          <td>10%</td>
                          <td>2</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadFC3"
                              placeholder={fcValores[2] || ''}
                              value={fcValores[2] || ''}
                              onChange={(e) => atualizaFc(2, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadPSE3"
                              placeholder={pseValores[2] || ''}
                              value={pseValores[2] || ''}
                              onChange={(e) => atualizaPse(2, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>8,0</td>
                          <td>10%</td>
                          <td>2</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadFC4"
                              placeholder={fcValores[3] || ''}
                              value={fcValores[3] || ''}
                              onChange={(e) => atualizaFc(3, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadPSE4"
                              placeholder={pseValores[3] || ''}
                              value={pseValores[3] || ''}
                              onChange={(e) => atualizaPse(3, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>8,0</td>
                          <td>15%</td>
                          <td>2</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadFC5"
                              placeholder={fcValores[4] || ''}
                              value={fcValores[4] || ''}
                              onChange={(e) => atualizaFc(4, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadPSE5"
                              placeholder={pseValores[4] || ''}
                              value={pseValores[4] || ''}
                              onChange={(e) => atualizaPse(4, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>9,6</td>
                          <td>15%</td>
                          <td>2</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadFC6"
                              placeholder={fcValores[5] || ''}
                              value={fcValores[5] || ''}
                              onChange={(e) => atualizaFc(5, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadPSE6"
                              placeholder={pseValores[5] || ''}
                              value={pseValores[5] || ''}
                              onChange={(e) => atualizaPse(5, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>11,2</td>
                          <td>15%</td>
                          <td>2</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadFC7"
                              placeholder={fcValores[6] || ''}
                              value={fcValores[6] || ''}
                              onChange={(e) => atualizaFc(6, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadPSE7"
                              placeholder={pseValores[6] || ''}
                              value={pseValores[6] || ''}
                              onChange={(e) => atualizaPse(6, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>12,8</td>
                          <td>15%</td>
                          <td>2</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadFC8"
                              placeholder={fcValores[7] || ''}
                              value={fcValores[7] || ''}
                              onChange={(e) => atualizaFc(7, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="ellestadPSE8"
                              placeholder={pseValores[7] || ''}
                              value={pseValores[7] || ''}
                              onChange={(e) => atualizaPse(7, e.target.value)}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className='pad-top-20'>
                      <div className='entrada-ellastad'>
                        <b className='entrada-tempo-outros'>Qual o perfil do avaliado? </b>
                        <input className="answer-radio" style={{marginLeft: 10, marginRight: -2}} type="radio" name="perfil" value="ativo" checked={perfil === 'ativo'} onChange={e => setPerfil(e.target.value)}/>
                        <span className='entrada-tempo-outros'>Ativo</span>
                        <input className="answer-radio" style={{marginLeft: 10, marginRight: -2}} type="radio" name="perfil" value="naoAtivo" checked={perfil === 'naoAtivo'} onChange={e => setPerfil(e.target.value)}/>
                        <span className='entrada-tempo-outros'>Não ativo</span>
                      </div>
                      <b className='entrada-tempo-outros'>Entre com o tempo: </b>
                      <input className="entrada-tabela-vo2" type="text" name="tempo" placeholder={tempo} value={tempo} onChange={e => setTempo(e.target.value)} />
                    </div>
                  </div>
                </div>
              )}
              {metodo === 'cooper' &&(
                <div>
                  <div className="question-title">Teste de Cooper 12min (protocolo em pista)</div>
                  <div style={{ position: "relative", display: "inline-block" }}>
                  <a
                    className="btt-vo2-procedimentos"
                    onMouseEnter={() => setShowInfoProcedimento(true)}
                    onMouseLeave={() => setShowInfoProcedimento(false)}
                  >
                    Procedimentos para realização do teste
                  </a>
                  {showInfoProcedimento && (
                    <div className="info-box-procedimentos">
                      <p>
                        <b>Objetivo: </b>
                        Estimar o VO₂máx com base na distância percorrida em 12 minutos de corrida contínua.
                        <br/><br/>
                        <b>Procedimento: </b>
                        Em uma pista plana (400 m), o avaliado deve correr a maior distância possível por 12 minutos, mantendo o maior ritmo sustentável.
                        <br/><br/>
                        <b>Orientações:</b>
                        <br/>
                        • Registrar a distância total percorrida ao final dos 12 minutos.<br/>
                        • Pode ser aplicado individualmente ou em grupo.<br/>
                        • Ideal para pessoas saudáveis com bom condicionamento físico.
                      </p>
                    </div>
                  )}
                </div>
                  <div className='pad-top-10'>
                    <b className='entrada-tempo-outros'>Entre com a distância (metros): </b>
                    <input className="entrada-tabela-vo2" type="text" name="distancia" placeholder={distancia} value={distancia} onChange={e => setDistancia(e.target.value)} />
                  </div>
                </div>
              )}
              {metodo === 'rockport' &&(
                <div>
                  <div className="question-title">Teste de 1 milha - (Rockport - 1.600mts)</div>
                  <div style={{ position: "relative", display: "inline-block" }}>
                  <a
                    className="btt-vo2-procedimentos"
                    onMouseEnter={() => setShowInfoProcedimento(true)}
                    onMouseLeave={() => setShowInfoProcedimento(false)}
                  >
                    Procedimentos para realização do teste
                  </a>
                  {showInfoProcedimento && (
                    <div className="info-box-procedimentos">
                      <p>
                        <b>Objetivo: </b>
                        Estimar o VO₂máx a partir da caminhada rápida de 1.600 metros e a frequência cardíaca final.
                        <br/><br/>
                        <b>Procedimento: </b>
                        O avaliado deve caminhar 1 milha (1.600 m) o mais rápido possível, sem correr. Ao término, mede-se a FC imediatamente.
                        <br/><br/>
                        <b>Orientações:</b>
                        <br/>
                        • Registrar tempo total (min) e FC final (bpm).<br/>
                        • Ideal para iniciantes e indivíduos sedentários.
                      </p>
                    </div>
                  )}
                </div>
                  <div className='pad-top-10'>
                    <b className='entrada-tempo-outros'>Entre com o tempo: </b>
                    <input className="entrada-tabela-vo2" type="text" name="tempo" placeholder={tempo} value={tempo} onChange={e => setTempo(e.target.value)} />
                  </div>
                  <div className='pad-top-10'>
                    <b className='entrada-tempo-outros'>Entre com a FC final: </b>
                    <input className="entrada-tabela-vo2" type="text" name="fcmax" placeholder={fcmax} value={fcmax} onChange={e => setFCmax(e.target.value)} />
                  </div>
                </div>
              )}
              {metodo === 'ukk' &&(
                <div>
                  <div className="question-title">Teste de UKK (2.000mts)</div>
                  <div style={{ position: "relative", display: "inline-block" }}>
                  <a
                    className="btt-vo2-procedimentos"
                    onMouseEnter={() => setShowInfoProcedimento(true)}
                    onMouseLeave={() => setShowInfoProcedimento(false)}
                  >
                    Procedimentos para realização do teste
                  </a>
                  {showInfoProcedimento && (
                    <div className="info-box-procedimentos">
                      <p>
                        <b>Objetivo: </b>
                        Estimar o VO₂máx com base na caminhada de 2.000 metros e parâmetros fisiológicos.
                        <br/><br/>
                        <b>Procedimento: </b>
                        O avaliado caminha 2.000 m o mais rápido possível (sem correr). Após o teste, anota-se o tempo e a FC final.
                        <br/><br/>
                        <b>Orientações:</b>
                        <br/>
                        • Também são necessários dados como idade, peso e altura.<br/>
                        • Indicado para pessoas de 20 a 65 anos, sem limitações graves de saúde.
                      </p>
                    </div>
                  )}
                </div>
                  <div className='pad-top-10'>
                    <b className='entrada-tempo-outros'>Entre com o tempo: </b>
                    <input className="entrada-tabela-vo2" type="text" name="tempo" placeholder={tempo} value={tempo} onChange={e => setTempo(e.target.value)} />
                  </div>
                  <div className='pad-top-10'>
                    <b className='entrada-tempo-outros'>Entre com a FC final: </b>
                    <input className="entrada-tabela-vo2" type="text" name="fcmax" placeholder={fcmax} value={fcmax} onChange={e => setFCmax(e.target.value)} />
                  </div>
                </div>
              )}
              {metodo === 'coconi' &&(
                <div>
                <div className="question-title">Teste de Coconi</div>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <a
                    className="btt-vo2-procedimentos"
                    onMouseEnter={() => setShowInfoProcedimento(true)}
                    onMouseLeave={() => setShowInfoProcedimento(false)}
                  >
                    Procedimentos para realização do teste
                  </a>
                  {showInfoProcedimento && (
                    <div className="info-box-procedimentos">
                      <p>
                        <b>Objetivo: </b>
                        Identificar os limiares aeróbio e anaeróbio pela resposta da frequência cardíaca a um teste progressivo em esteira.
                        <br/><br/>
                        <b>Procedimento: </b>
                        Corrida em esteira com estágios de velocidade crescente (5 km/h nos três primeiros estágios e, a partir daí, +1 km/h por estágio até 20 km/h). Ao final de cada estágio registra-se a FC e a percepção de esforço. Os limiares correspondem aos dois maiores saltos de FC entre estágios consecutivos, e a velocidade informada é a do estágio em que cada salto ocorreu.
                        <br/><br/>
                        <b>Orientações:</b>
                        <br/>
                        • Teste termina quando o avaliado não consegue manter o ritmo imposto.<br/>
                        • Registrar o último estágio concluído com sucesso para análise de limiar.
                      </p>
                    </div>
                  )}
                </div>
                <div className="horizontal-scroll-table">
                  <div className='pad-top-10'>
                    <b className='entrada-tempo-outros'>Entre com a FC em repouso:</b>
                    <input className="entrada-tabela-vo2" style={{marginLeft: 5}} type="text" name="fcRepouso" placeholder={fcRepouso} value={fcRepouso} onChange={e => setFCrepouso(e.target.value)} />
                  </div>
                  <table className="tabela-geral-vo2 pad-top-20">
                      <thead>
                        <tr>
                          <th>Estágio</th>
                          <th>Velocidade (km/h)</th>
                          <th>Inclinação</th>
                          <th>Minutos</th>
                          <th>FC</th>
                          <th>PSE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>5</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC1"
                              placeholder={fcValores[0] || ''}
                              value={fcValores[0] || ''}
                              onChange={(e) => atualizaFc(0, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE1"
                              placeholder={pseValores[0] || ''}
                              value={pseValores[0] || ''}
                              onChange={(e) => atualizaPse(0, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>5</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC2"
                              placeholder={fcValores[1] || ''}
                              value={fcValores[1] || ''}
                              onChange={(e) => atualizaFc(1, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE2"
                              placeholder={pseValores[1] || ''}
                              value={pseValores[1] || ''}
                              onChange={(e) => atualizaPse(1, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>5</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC3"
                              placeholder={fcValores[2] || ''}
                              value={fcValores[2] || ''}
                              onChange={(e) => atualizaFc(2, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE3"
                              placeholder={pseValores[2] || ''}
                              value={pseValores[2] || ''}
                              onChange={(e) => atualizaPse(2, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>6</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC4"
                              placeholder={fcValores[3] || ''}
                              value={fcValores[3] || ''}
                              onChange={(e) => atualizaFc(3, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE4"
                              placeholder={pseValores[3] || ''}
                              value={pseValores[3] || ''}
                              onChange={(e) => atualizaPse(3, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>7</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC5"
                              placeholder={fcValores[4] || ''}
                              value={fcValores[4] || ''}
                              onChange={(e) => atualizaFc(4, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE5"
                              placeholder={pseValores[4] || ''}
                              value={pseValores[4] || ''}
                              onChange={(e) => atualizaPse(4, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>8</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[5] || ''}
                              value={fcValores[5] || ''}
                              onChange={(e) => atualizaFc(5, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[5] || ''}
                              value={pseValores[5] || ''}
                              onChange={(e) => atualizaPse(5, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>9</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[6] || ''}
                              value={fcValores[6] || ''}
                              onChange={(e) => atualizaFc(6, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[6] || ''}
                              value={pseValores[6] || ''}
                              onChange={(e) => atualizaPse(6, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>10</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[7] || ''}
                              value={fcValores[7] || ''}
                              onChange={(e) => atualizaFc(7, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[7] || ''}
                              value={pseValores[7] || ''}
                              onChange={(e) => atualizaPse(7, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>11</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[8] || ''}
                              value={fcValores[8] || ''}
                              onChange={(e) => atualizaFc(8, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[8] || ''}
                              value={pseValores[8] || ''}
                              onChange={(e) => atualizaPse(8, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>12</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[9] || ''}
                              value={fcValores[9] || ''}
                              onChange={(e) => atualizaFc(9, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[9] || ''}
                              value={pseValores[9] || ''}
                              onChange={(e) => atualizaPse(9, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>13</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[10] || ''}
                              value={fcValores[10] || ''}
                              onChange={(e) => atualizaFc(10, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[10] || ''}
                              value={pseValores[10] || ''}
                              onChange={(e) => atualizaPse(10, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>14</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[11] || ''}
                              value={fcValores[11] || ''}
                              onChange={(e) => atualizaFc(11, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[11] || ''}
                              value={pseValores[11] || ''}
                              onChange={(e) => atualizaPse(11, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>15</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[12] || ''}
                              value={fcValores[12] || ''}
                              onChange={(e) => atualizaFc(12, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[12] || ''}
                              value={pseValores[12] || ''}
                              onChange={(e) => atualizaPse(12, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>14</td>
                          <td>16</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[13] || ''}
                              value={fcValores[13] || ''}
                              onChange={(e) => atualizaFc(13, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[13] || ''}
                              value={pseValores[13] || ''}
                              onChange={(e) => atualizaPse(13, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>17</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[14] || ''}
                              value={fcValores[14] || ''}
                              onChange={(e) => atualizaFc(14, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[14] || ''}
                              value={pseValores[14] || ''}
                              onChange={(e) => atualizaPse(14, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>18</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[15] || ''}
                              value={fcValores[15] || ''}
                              onChange={(e) => atualizaFc(15, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[15] || ''}
                              value={pseValores[15] || ''}
                              onChange={(e) => atualizaPse(15, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>17</td>
                          <td>19</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[16] || ''}
                              value={fcValores[16] || ''}
                              onChange={(e) => atualizaFc(16, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[16] || ''}
                              value={pseValores[16] || ''}
                              onChange={(e) => atualizaPse(16, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>18</td>
                          <td>20</td>
                          <td>1%</td>
                          <td>1</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiFC6"
                              placeholder={fcValores[17] || ''}
                              value={fcValores[17] || ''}
                              onChange={(e) => atualizaFc(17, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="coconiPSE6"
                              placeholder={pseValores[17] || ''}
                              value={pseValores[17] || ''}
                              onChange={(e) => atualizaPse(17, e.target.value)}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {metodo === 'ventilatorio' &&(
                <div>
                    <div className="question-title">Teste incremental para estimativa dos limiares ventilatórios (teste em esteira)</div>
                    <div style={{ position: "relative", display: "inline-block" }}>
                      <a
                        className="btt-vo2-procedimentos"
                        onMouseEnter={() => setShowInfoProcedimento(true)}
                        onMouseLeave={() => setShowInfoProcedimento(false)}
                      >
                        Procedimentos para realização do teste
                      </a>
                      {showInfoProcedimento && (
                        <div className="info-box-procedimentos">
                          <p>
                            <b>Objetivo: </b>
                            Identificar os limiares ventilatórios (aeróbico e anaeróbico) por meio da resposta cardiorrespiratória a esforços crescentes.
                            <br/><br/>
                            <b>Procedimento: </b>
                            • Teste progressivo, com aumentos de velocidade a cada 1 a 3 minutos.<br/>
                            • Inicia-se com intensidade leve, aumentando até a exaustão.<br/>
                            • Realizar coleta de frequência cardíaca e percepção de esforço em cada estágio.
                            <br/><br/>
                            <b>Orientações:</b>
                            <br/>
                            • Pode ser usado com análise de gases (espirometria) ou estimativas indiretas (FC, VE/VO₂, VE/VCO₂).<br/>
                            • Indicado para atletas ou avaliações clínicas detalhadas.
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="horizontal-scroll-table">
                      <div className='pad-top-10'>
                        <b className='entrada-tempo-outros'>Entre com a FC em repouso:</b>
                        <input className="entrada-tabela-vo2 margin-left-5" type="text" name="fcRepouso" placeholder={fcRepouso} value={fcRepouso} onChange={e => setFCrepouso(e.target.value)} />
                      </div>
                      <table className="tabela-geral-vo2 pad-top-20">
                        <thead>
                          <tr>
                            <th>Estágio</th>
                            <th>Velocidade (km/h)</th>
                            <th>Inclinação</th>
                            <th>Minutos</th>
                            <th>FC</th>
                            <th>PSE</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>5</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC1"
                                placeholder={fcValores[0] || ''}
                                value={fcValores[0] || ''}
                                onChange={(e) => atualizaFc(0, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE1"
                                placeholder={pseValores[0] || ''}
                                value={pseValores[0] || ''}
                                onChange={(e) => atualizaPse(0, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>5</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC2"
                                placeholder={fcValores[1] || ''}
                                value={fcValores[1] || ''}
                                onChange={(e) => atualizaFc(1, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE2"
                                placeholder={pseValores[1] || ''}
                                value={pseValores[1] || ''}
                                onChange={(e) => atualizaPse(1, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>5</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC3"
                                placeholder={fcValores[2] || ''}
                                value={fcValores[2] || ''}
                                onChange={(e) => atualizaFc(2, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE3"
                                placeholder={pseValores[2] || ''}
                                value={pseValores[2] || ''}
                                onChange={(e) => atualizaPse(2, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>6</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC4"
                                placeholder={fcValores[3] || ''}
                                value={fcValores[3] || ''}
                                onChange={(e) => atualizaFc(3, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE4"
                                placeholder={pseValores[3] || ''}
                                value={pseValores[3] || ''}
                                onChange={(e) => atualizaPse(3, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>7</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC5"
                                placeholder={fcValores[4] || ''}
                                value={fcValores[4] || ''}
                                onChange={(e) => atualizaFc(4, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE5"
                                placeholder={pseValores[4] || ''}
                                value={pseValores[4] || ''}
                                onChange={(e) => atualizaPse(4, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>8</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[5] || ''}
                                value={fcValores[5] || ''}
                                onChange={(e) => atualizaFc(5, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[5] || ''}
                                value={pseValores[5] || ''}
                                onChange={(e) => atualizaPse(5, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>9</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[6] || ''}
                                value={fcValores[6] || ''}
                                onChange={(e) => atualizaFc(6, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[6] || ''}
                                value={pseValores[6] || ''}
                                onChange={(e) => atualizaPse(6, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>10</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[7] || ''}
                                value={fcValores[7] || ''}
                                onChange={(e) => atualizaFc(7, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[7] || ''}
                                value={pseValores[7] || ''}
                                onChange={(e) => atualizaPse(7, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>11</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[8] || ''}
                                value={fcValores[8] || ''}
                                onChange={(e) => atualizaFc(8, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[8] || ''}
                                value={pseValores[8] || ''}
                                onChange={(e) => atualizaPse(8, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>12</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[9] || ''}
                                value={fcValores[9] || ''}
                                onChange={(e) => atualizaFc(9, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[9] || ''}
                                value={pseValores[9] || ''}
                                onChange={(e) => atualizaPse(9, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>11</td>
                            <td>13</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[10] || ''}
                                value={fcValores[10] || ''}
                                onChange={(e) => atualizaFc(10, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[10] || ''}
                                value={pseValores[10] || ''}
                                onChange={(e) => atualizaPse(10, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>12</td>
                            <td>14</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[11] || ''}
                                value={fcValores[11] || ''}
                                onChange={(e) => atualizaFc(11, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[11] || ''}
                                value={pseValores[11] || ''}
                                onChange={(e) => atualizaPse(11, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>13</td>
                            <td>15</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[12] || ''}
                                value={fcValores[12] || ''}
                                onChange={(e) => atualizaFc(12, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[12] || ''}
                                value={pseValores[12] || ''}
                                onChange={(e) => atualizaPse(12, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>14</td>
                            <td>16</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[13] || ''}
                                value={fcValores[13] || ''}
                                onChange={(e) => atualizaFc(13, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[13] || ''}
                                value={pseValores[13] || ''}
                                onChange={(e) => atualizaPse(13, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>15</td>
                            <td>17</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[14] || ''}
                                value={fcValores[14] || ''}
                                onChange={(e) => atualizaFc(14, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[14] || ''}
                                value={pseValores[14] || ''}
                                onChange={(e) => atualizaPse(14, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>16</td>
                            <td>18</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[15] || ''}
                                value={fcValores[15] || ''}
                                onChange={(e) => atualizaFc(15, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[15] || ''}
                                value={pseValores[15] || ''}
                                onChange={(e) => atualizaPse(15, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>17</td>
                            <td>19</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[16] || ''}
                                value={fcValores[16] || ''}
                                onChange={(e) => atualizaFc(16, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[16] || ''}
                                value={pseValores[16] || ''}
                                onChange={(e) => atualizaPse(16, e.target.value)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>18</td>
                            <td>20</td>
                            <td>1%</td>
                            <td>1</td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioFC6"
                                placeholder={fcValores[17] || ''}
                                value={fcValores[17] || ''}
                                onChange={(e) => atualizaFc(17, e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                name="ventilatorioPSE6"
                                placeholder={pseValores[17] || ''}
                                value={pseValores[17] || ''}
                                onChange={(e) => atualizaPse(17, e.target.value)}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>

                    <div className='pad-top-10 pad-bot-20'>
                      <b className='entrada-tempo-outros'>Entre com o pico de velocidade:</b>
                      <input className="entrada-tabela-vo2 margin-left-5" type="text" name="velocidade" placeholder={velocidade} value={velocidade} onChange={e => setVelocidade(e.target.value)} />
                    </div>
                  </div>  
                </div>
              )}
              {metodo === 'astrand' &&(
                <div>
                  <div className="question-title">Teste máximo de Astrand e Rodahhl - bicicleta</div>
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <a
                      className="btt-vo2-procedimentos"
                      onMouseEnter={() => setShowInfoProcedimento(true)}
                      onMouseLeave={() => setShowInfoProcedimento(false)}
                    >
                      Procedimentos para realização do teste
                    </a>
                    {showInfoProcedimento && (
                      <div className="info-box-procedimentos">
                        <p>
                          <b>Objetivo: </b>
                          Determinar o VO₂máx com esforço máximo progressivo em cicloergômetro.
                          <br/><br/>
                          <b>Procedimento: </b>
                          O avaliado pedala com carga crescente a cada 2 a 3 minutos até a exaustão. A cadência deve ser mantida entre 50–60 rpm.
                          <br/><br/>
                          <b>Orientações:</b>
                          <br/>
                          • Ideal para atletas ou avaliações clínicas com controle fisiológico.<br/>
                          • Registrar a frequência cardíaca a cada minuto durante o teste.<br/>
                          • Se a frequência cardíaca em estado estacionário atingida não estiver entre 125 e 170 bpm, ajustar a
                           carga de trabalho apropriadamente e continuar por um segundo período de 6 minutos. Caso contrário, o teste é concluído.<br/>
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="horizontal-scroll-table">
                    <table className="tabela-geral-vo2">
                      <thead>
                        <tr>
                          <th>Minutos</th>
                          <th>Estágio</th>
                          <th>Carga (watts)</th>
                          <th>Velocidade (rpm)</th>
                          <th>FC</th>
                          <th>PSE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>1</td>
                          <td>50</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC1"
                              placeholder={fcValores[0] || ''}
                              value={fcValores[0] || ''}
                              onChange={(e) => atualizaFc(0, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE1"
                              placeholder={pseValores[0] || ''}
                              value={pseValores[0] || ''}
                              onChange={(e) => atualizaPse(0, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>1</td>
                          <td>50</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC2"
                              placeholder={fcValores[1] || ''}
                              value={fcValores[1] || ''}
                              onChange={(e) => atualizaFc(1, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE2"
                              placeholder={pseValores[1] || ''}
                              value={pseValores[1] || ''}
                              onChange={(e) => atualizaPse(1, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>1</td>
                          <td>50</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC3"
                              placeholder={fcValores[2] || ''}
                              value={fcValores[2] || ''}
                              onChange={(e) => atualizaFc(2, e.target.value)}
                            />
                          </td> 
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE3"
                              placeholder={pseValores[2] || ''}
                              value={pseValores[2] || ''}
                              onChange={(e) => atualizaPse(2, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>2</td>
                          <td>75</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC4"
                              placeholder={fcValores[3] || ''}
                              value={fcValores[3] || ''}
                              onChange={(e) => atualizaFc(3, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE4"
                              placeholder={pseValores[3] || ''}
                              value={pseValores[3] || ''}
                              onCha nge={(e) => atualizaPse(3, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>2</td>
                          <td>75</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC5"
                              placeholder={fcValores[4] || ''}
                              value={fcValores[4] || ''}
                              onChange={(e) => atualizaFc(4, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE5"
                              placeholder={pseValores[4] || ''}
                              value={pseValores[4] || ''}
                              onChange={(e) => atualizaPse(4, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>2</td>
                          <td>75</td>
                          <td>60</ td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC6"
                              placeholder={fcValores[5] || ''}
                              value={fcValores[5] || ''}
                              onChange={(e) => atualizaFc(5, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE6"
                              placeholder={pseValores[5] || ''}
                              value={pseValores[5] || ''}
                              onChange={(e) => atualizaPse(5, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>3</td>
                          <td>100</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC6"
                              placeholder={fcValores[6] || ''}
                              value={fcValores[6] || ''}
                              onC hange={(e) => atualizaFc(6, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE6"
                              placeholder={pseValores[6] || ''}
                              value={pseValores[6] || ''}
                              onChange={(e) => atualizaPse(6, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>3</td>
                          <td>100</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC6"
                              placeholder={fcValores[7] || ''}
                              value={fcValores[7] || ''}
                              onChange={(e) => atualizaFc(7, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE6"
                              pl aceholder={pseValores[7] || ''}
                              value={pseValores[7] || ''}
                              onChange={(e) => atualizaPse(7, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>3</td>
                          <td>100</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC6"
                              placeholder={fcValores[8] || ''}
                              value={fcValores[8] || ''}
                              onChange={(e) => atualizaFc(8, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE6"
                              placeholder={pseValores[8] || ''}
                              value={pseValores[8] || ''}
                              onChange={(e) => atualizaPse(8, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>4 </td>
                          <td>150</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC6"
                              placeholder={fcValores[9] || ''}
                              value={fcValores[9] || ''}
                              onChange={(e) => atualizaFc(9, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE6"
                              placeholder={pseValores[9] || ''}
                              value={pseValores[9] || ''}
                              onChange={(e) => atualizaPse(9, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>4</td>
                          <td>150</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC6"
                                placeholder={fcValores[10] || ''}
                              value={fcValores[10] || ''}
                              onChange={(e) => atualizaFc(10, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE6"
                              placeholder={pseValores[10] || ''}
                              value={pseValores[10] || ''}
                              onChange={(e) => atualizaPse(10, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>4</td>
                          <td>150</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC6"
                              placeholder={fcValores[11] || ''}
                              value={fcValores[11] || ''}
                              onChange={(e) => atualizaFc(11, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                                type="text"
                              name="astrandPSE6"
                              placeholder={pseValores[11] || ''}
                              value={pseValores[11] || ''}
                              onChange={(e) => atualizaPse(11, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>5</td>
                          <td>200</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC6"
                              placeholder={fcValores[12] || ''}
                              value={fcValores[12] || ''}
                              onChange={(e) => atualizaFc(12, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE6"
                              placeholder={pseValores[12] || ''}
                              value={pseValores[12] || ''}
                              onChange={(e) => atualizaPse(12, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr> 
                          <td>14</td>
                          <td>5</td>
                          <td>200</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandFC6"
                              placeholder={fcValores[13] || ''}
                              value={fcValores[13] || ''}
                              onChange={(e) => atualizaFc(13, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE6"
                              placeholder={pseValores[13] || ''}
                              value={pseValores[13] || ''}
                              onChange={(e) => atualizaPse(13, e.target.value)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>5</td>
                          <td>200</td>
                          <td>60</td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                                type="text"
                              name="astrandFC6"
                              placeholder={fcValores[14] || ''}
                              value={fcValores[14] || ''}
                              onChange={(e) => atualizaFc(14, e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              className="entrada-tabela-vo2"
                              type="text"
                              name="astrandPSE6"
                              placeholder={pseValores[14] || ''}
                              value={pseValores[14] || ''}
                              onChange={(e) => atualizaPse(14, e.target.value)}
                            />
                          </td>
                        </tr> 
                      </tbody>
                    </table>
                    <div className='pad-top-20'>
                      <b className='entrada-tempo-outros'>Entre com os Watts:</b>
                      <input className="entrada-tabela-vo2 margin-left-5" type="text" name="watts" placeholder={watts} value={watts} onChange={e => setWatts(e.target.value)} />
                    </div>
                    <div className='pad-top-10'>
                      <b className='entrada-tempo-outros'>Entre com a frequência cardíaca em estado estacionário após 6 minutos de exercício  </b>
                      <input className="entrada-tabela-vo2" type="text" name="fcHRss" placeholder={fcHRss} value={fcHRss} onChange={e => setFCHRss(e.target.value)} /><br/>
                      Observação: A frequência cardíaca no estado estacionario deve estar entre 125 - 170 Bpm para a validação do teste.
                  </div>
                  </div>
                </div>
              )}
              {metodo === 'astrand8min' &&(
                <div>
                  <div className="question-title">Teste submáximo de Astrand 8 minutos - bicicleta</div>
                  <div style={{ position: "relative", display: "inline-block" }}>
                  <a
                    className="btt-vo2-procedimentos"
                    onMouseEnter={() => setShowInfoProcedimento(true)}
                    onMouseLeave={() => setShowInfoProcedimento(false)}
                  >
                    Procedimentos para realização do teste
                  </a>
                  {showInfoProcedimento && (
                    <div className="info-box-procedimentos">
                      <p>
                        <b>Objetivo: </b>
                        Estimar o VO₂máx com base na resposta da frequência cardíaca durante um esforço submáximo constante.
                        <br/><br/>
                        <b>Procedimento: </b>
                        • O avaliado pedala por 6 minutos em uma carga constante (definida por sexo e nível de atividade).<br/>
                        • Cadência: 50 rpm.<br/>
                        • Medir a FC nos minutos 5 e 6.
                        <br/><br/>
                        <b>Orientações:</b>
                        <br/>
                        • Usar gráfico de nomograma de Astrand-Rhyming ou fórmulas para estimar VO₂máx.<br/>
                        • Corrigir o valor com fator de idade.
                      </p>
                    </div>
                  )}
                </div>
                  <table className="tabela-geral-vo2">
                    <thead>
                      <tr>
                        <th >Estágio</th>
                        <th>FC</th>
                        <th>PSE</th>
                        <th>Carga de esforço</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minFC1"
                            placeholder={fcValores[0] || ''}
                            value={fcValores[0] || ''}
                            onChange={(e) => atualizaFc(0, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minPSE1"
                            placeholder={pseValores[0] || ''}
                            value={pseValores[0] || ''}
                            onChange={(e) => atualizaPse(0, e.target.value)}
                          />
                        </td>
                        <td>1kg</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>
                            <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minFC1"
                            placeholder={fcValores[1] || ''}
                            value={fcValores[1] || ''}
                            onChange={(e) => atualizaFc(1, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minPSE1"
                            placeholder={pseValores[1] || ''}
                            value={pseValores[1] || ''}
                            onChange={(e) => atualizaPse(1, e.target.value)}
                          />
                        </td>
                        <td>1kg</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minFC1"
                            placeholder={fcValores[2] || ''}
                            value={fcValores[2] || ''}
                            onChange={(e) => atualizaFc(2, e.target.value)}
                          />
                        </td>
                        <td>
                            <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minPSE1"
                            placeholder={pseValores[2] || ''}
                            value={pseValores[2] || ''}
                            onChange={(e) => atualizaPse(2, e.target.value)}
                          />
                        </td>
                        <td>1kg</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minFC1"
                            placeholder={fcValores[3] || ''}
                            value={fcValores[3] || ''}
                            onChange={(e) => atualizaFc(3, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minPSE1"
                            placeholder={pseValores[3] || ''}
                            value={pseValores[3] || ''}
                            onChange={(e) => atualizaPse(3, e.target.value)}
                          />
                        </td>
                        <td>1kg</td>
                      </ tr>
                      <tr>
                        <td>5</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minFC1"
                            placeholder={fcValores[4] || ''}
                            value={fcValores[4] || ''}
                            onChange={(e) => atualizaFc(4, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minPSE1"
                            placeholder={pseValores[4] || ''}
                            value={pseValores[4] || ''}
                            onChange={(e) => atualizaPse(4, e.target.value)}
                          />
                        </td>
                        <td>{formatarNumero((peso * 0.04), 0)}kg</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minFC1"
                            placeholder={fcValores[5] || ''}
                            value={fcValores[5] || ''}
                              onChange={(e) => atualizaFc(5, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minPSE1"
                            placeholder={pseValores[5] || ''}
                            value={pseValores[5] || ''}
                            onChange={(e) => atualizaPse(5, e.target.value)}
                          />
                        </td>
                        <td>{formatarNumero((peso * 0.04), 0)}kg</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minFC1"
                            placeholder={fcValores[6] || ''}
                            value={fcValores[6] || ''}
                            onChange={(e) => atualizaFc(6, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minPSE1"
                            placeholder={pseValores[6] || ''}
                            value={pseValores[6] || ''}
                              onChange={(e) => atualizaPse(6, e.target.value)}
                          />
                        </td>
                        <td>{formatarNumero((peso * 0.04), 0)}kg</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minFC1"
                            placeholder={fcValores[7] || ''}
                            value={fcValores[7] || ''}
                            onChange={(e) => atualizaFc(7, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="astrand8minPSE1"
                            placeholder={pseValores[7] || ''}
                            value={pseValores[7] || ''}
                            onChange={(e) => atualizaPse(7, e.target.value)}
                          />
                        </td>
                        <td>{formatarNumero((peso * 0.04), 0)}kg</td>
                      </tr>
                    </tbody>
                  </table>

                  <div className='pad-top-20'>
                    <b className='entrada-tempo-outros'>Entre com os Watts:</b>
                    < input className="entrada-tabela-vo2 margin-left-5" type="text" name="watts" placeholder={watts} value={watts} onChange={e => setWatts(e.target.value)} />
                  </div>
                </div>
              )}
              {metodo === 'fox' &&(
                <div>
                  <div className="question-title">Teste submáximo de Fox - bicicleta</div>
                  <div style={{ position: "relative", display: "inline-block" }}>
                  <a
                    className="btt-vo2-procedimentos"
                    onMouseEnter={() => setShowInfoProcedimento(true)}
                    onMouseLeave={() => setShowInfoProcedimento(false)}
                  >
                    Procedimentos para realização do teste
                  </a>
                  {showInfoProcedimento && (
                    <div className="info-box-procedimentos">
                      <p>
                        <b>Objetivo: </b>
                        Estimar o VO₂máx por meio de resposta cardiorrespiratória ao exercício em bicicleta.
                        <br/><br/>
                        <b>Procedimento: </b>
                        • O avaliado pedala por 5 minutos em carga fixa de 150 W (900 kgm/min), com cadência em torno de 60 rpm.<br/>
                        • Registrar a FC ao final do 5º minuto: ela entra na equação de Fox (VO₂máx = 6.300 – 19,26 × FC), que o sistema utiliza.
                        <br/><br/>
                        <b>Orientações:</b>
                        <br/>
                        • Monitorar FC continuamente.<br/>
                        • Estimar o VO₂máx com base na carga e resposta da FC.
                      </p>
                    </div>
                  )}
                </div>
                  <div className='pad-top-20'>
                    <b className='entrada-tempo-outros'>Entre com a FC final:</b>
                    <input className="entrada-tabela-vo2 margin-left-5" type="text" name="fcmax" placeholder={fcmax} value={fcmax} onChange={e => setFCmax(e.target.value)} />
                  </div>
                </div>
              )}
              {metodo === 'banco' &&(
                <div>
                  <div className="question-title">Teste submáximo em banco (Katch e McArdle, 1972)</div>
                  <div style={{ position: "relative", display: "inline-block" }}>
                  <a
                    className="btt-vo2-procedimentos"
                    onMouseEnter={() => setShowInfoProcedimento(true)}
                    onMouseLeave={() => setShowInfoProcedimento(false)}
                  >
                    Procedimentos para realização do teste
                  </a>
                  {showInfoProcedimento && (
                    <div className="info-box-procedimentos">
                      <p>
                        <b>Objetivo: </b>
                        Estimar o VO₂máx com base na FC de recuperação após exercício padronizado em banco.
                        <br/><br/>
                        <b>Procedimento: </b>
                        • Banco: 40,6 cm (homens) ou 33 cm (mulheres).<br/>
                        • Subidas por 3 minutos (cadência: 24/min homens, 22/min mulheres).<br/>
                        • Após o teste, medir FC entre 5 e 20 segundos da recuperação (multiplicar por 4).
                        <br/><br/>
                        <b>Orientações:</b>
                        <br/>
                        • Aplicação prática e simples.<br/>
                        • Equações específicas para homens e mulheres.
                      </p>
                    </div>
                  )}
                </div>
                  <div className='pad-top-20'>
                    <b className='entrada-tempo-outros'>Entre com a FC de recuperação:</b>
                    <input className="entrada-tabela-vo2 margin-left-5" type="text" name="fcmax" placeholder={fcmax} value={fcmax} onChange={e => setFCmax(e.target.value)} />
                  </div>
                </div>
              )}
              {metodo === 'bruceBic' &&(
                <div>
                  <div className="question-title">Teste máximo de Bruce - bicicleta</div>
                  <div style={{ position: "relative", display: "inline-block" }}>
                  <a
                    className="btt-vo2-procedimentos"
                    onMouseEnter={() => setShowInfoProcedimento(true)}
                    onMouseLeave={() => setShowInfoProcedimento(false)}
                  >
                    Procedimentos para realização do teste
                  </a>
                  {showInfoProcedimento && (
                    <div className="info-box-procedimentos">
                      <p>
                        <b>Objetivo: </b>
                        Versão adaptada do protocolo Bruce para cicloergômetro, com incremento progressivo da carga até a exaustão.
                        <br/><br/>
                        <b>Procedimento: </b>
                        • Carga inicial baixa (ex: 25 watts), com aumentos a cada 3 minutos.<br/>
                        • Manter cadência entre 50–60 rpm.
                        <br/><br/>
                        <b>Orientações:</b>
                        <br/>
                        • Registrar tempo e carga máxima atingida.<br/>
                        • Calcular VO₂máx com fórmulas baseadas em carga máxima.
                      </p>
                    </div>
                  )}
                </div>
                  <table className="tabela-geral-vo2">
                    <thead>
                      <tr>
                          <th>Estágio</th>
                        <th>Potência (watts)</th>
                        <th>Duração (min)</th>
                        <th>Velocidade (rpm)</th>
                        <th>FC</th>
                        <th>PSE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>50 - 75</td>
                        <td>2 - 3</td>
                        <td>50 - 70</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceBicFC1"
                            placeholder={fcValores[0] || ''}
                            value={fcValores[0] || ''}
                            onChange={(e) => atualizaFc(0, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2 margin-left-5"
                            type="text"
                            name="bruceBicPSE1"
                            placeholder={pseValores[0] || ''}
                            value={pseValores[0] || ''}
                            onChange={(e) => atualizaPse(0, e.target.value)}
                          />
                        </td>
                        </tr>
                      <tr>
                        <td>2</td>
                        <td>100</td>
                        <td>2 - 3</td>
                        <td>50 - 70</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceBicFC1"
                            placeholder={fcValores[1] || ''}
                            value={fcValores[1] || ''}
                            onChange={(e) => atualizaFc(1, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceBicPSE1"
                            placeholder={pseValores[1] || ''}
                            value={pseValores[1] || ''}
                            onChange={(e) => atualizaPse(1, e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>150</td>
                        <td>2 - 3</td>
                        <td>50 - 70</td>
                        <td>
                          <input
                              className="entrada-tabela-vo2"
                            type="text"
                            name="bruceBicFC1"
                            placeholder={fcValores[2] || ''}
                            value={fcValores[2] || ''}
                            onChange={(e) => atualizaFc(2, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceBicPSE1"
                            placeholder={pseValores[2] || ''}
                            value={pseValores[2] || ''}
                            onChange={(e) => atualizaPse(2, e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>200</td>
                        <td>2 - 3</td>
                        <td>50 - 70</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceBicFC1"
                            placeholder={fcValores[3] || ''}
                            value={fcValores[3] || ''}
                            onChange={(e) => atualizaFc(3, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceBicPSE1"
                            placeholder={pseValores[3] || ''}
                            value={pseValores[3] || ''}
                            onChange={(e) => atualizaPse(3, e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>250</td>
                        <td>2 - 3</td>
                        <td>50 - 70</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceBicFC1"
                            placeholder={fcValores[4] || ''}
                            value={fcValores[4] || ''}
                            onChange={(e) => atualizaFc(4, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceBicPSE1"
                            placeholder={pseValores[4] || ''}
                            value={pseValores[4] || ''}
                            onChange={(e) => atualizaPse(4, e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>300</td>
                        <td>2 - 3</td>
                        <td>50 - 70</td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceBicFC1"
                            placeholder={fcValores[5] || ''}
                            value={fcValores[5] || ''}
                            onChange={(e) => atualizaFc(5, e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            className="entrada-tabela-vo2"
                            type="text"
                            name="bruceBicPSE1"
                            placeholder={pseValores[5] || ''}
                            value={pseValores[5] || ''}
                            onChange={(e) => atualizaPse(5, e.target.value)}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className='pad-top-20'>
                    <b className='entrada-tempo-outros'>Entre com os Watts:</b>
                    <input className="entrada-tabela-vo2 margin-left-5" type="text" name="watts" placeholder={watts} value={watts} onChange={e => setWatts(e.target.value)} />
                  </div>
                </div>
              )}
              {metodo === 'astrandBic' &&(
                <div>
                  <div className="question-title">Teste submáximo de Astrand-Rhyming (carga única) - bicicleta</div>
                  <div style={{ position: "relative", display: "inline-block" }}>
                  <a
                    className="btt-vo2-procedimentos"
                    onMouseEnter={() => setShowInfoProcedimento(true)}
                    onMouseLeave={() => setShowInfoProcedimento(false)}
                  >
                    Procedimentos para realização do teste
                  </a>
                  {showInfoProcedimento && (
                    <div className="info-box-procedimentos">
                      <p>
                        <b>Objetivo: </b>
                        Estimar o VO₂máx a partir da FC em esforço constante por 6 minutos.
                        <br/><br/>
                        <b>Procedimento: </b>
                        • Carga fixa (ex: 300 ou 450 kgm/min), conforme sexo e nível de atividade.<br/>
                        • Cadência: 50 rpm.<br/>
                        • Medir a FC nos minutos 5 e 6.
                        <br/><br/>
                        <b>Orientações:</b>
                        <br/>
                        • Usar nomograma de Astrand ou equações específicas.<br/>
                        • Corrigir o valor pelo fator de idade.
                      </p>
                    </div>
                  )}
                </div>
                  <div className='pad-top-20'>
                    <b className='entrada-tempo-outros'>Entre com os watts:</b>
                    <input className="entrada-tabela-vo2 margin-left-5" type="text" name="watts" placeholder={watts} value={watts} onChange={e => setWatts(e.target.value)} />
                  </div>
                  <div className='pad-top-10'>
                    <b className='entrada-tempo-outros'>Entre com a FC submáxima:</b>
                    <input className="entrada-tabela-vo2 margin-left-5" type="text" name="fcmax" placeholder={fcmax} value={fcmax} onChange={e => setFCmax(e.target.value)} />
                  </div>
                </div>
              )}
            </div>

            <div className="questions-right">
              <div className="question-title">Resultados</div>
                {(metodo === 'bruce' || metodo === 'balke' || metodo === 'ellestad' || metodo === 'rockport' || metodo === 'ukk'
                || metodo === 'fox' || metodo === 'banco' || metodo === 'bruceBic' || metodo === 'astrandBic' || metodo === 'astrand8min') &&(
                  <div className="resultado-vo2-container">
                    <table className="table-result-vo2">
                      <thead>
                        <tr>
                          <th>VO₂ Max (mL/kg/min)</th>
                          <th>VO₂ Max (L/min)</th>
                          <th>METs</th>
                          <th>FC Max (Bpm)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{vo2}</td>
                          <td>{formatarNumero(((vo2 * peso) / 1000), 1)}</td>
                          <td>{formatarNumero((vo2 / 3.5), 1)}</td>
                          <td>{fcmax}</td>
                        </tr>
                      </tbody>
                    </table>
                    <GraficoBarraComIndicador valor={vo2} faixas={faixasVO2calculadas} />
                    {encontrarFaixa(vo2, faixasVO2calculadas) && (
                    <div
                        className="resultado-classificacao margin-top-15"
                        style={{ border: `2px solid ${encontrarFaixa(vo2, faixasVO2calculadas)?.color}`}}>
                        <span>
                          Classificação: <strong>{encontrarFaixa(vo2, faixasVO2calculadas)?.name}</strong>
                        </span>
                      </div>
                    )}

                    <div className="resultado-referencia-vo2">
                      <p className='vo2-info-title'>Valores de referência</p>
                      <p className='vo2-info-sub-title'>Estimados por Idade e Gordura corporal</p>
                      <p className='vo2-info-content pad-top-10'>VO2 estimado: <span>{vo2Preditivo}</span> (mL/kg/min)</p>
                      <p className='vo2-info-content'>FC máxima estimada: <span>{fcmaxEstimada}</span> bpm</p>
                    </div>

                  </div>
                )}
                {(metodo === 'cooper') &&(
                  <div className="resultado-vo2-container">
                    <table className="table-result-vo2">
                      <thead>
                        <tr>
                          <th>VO₂ Max (mL/kg/min)</th>
                          <th>VO₂ Max (L/min)</th>
                          <th>METs</th>
                          <th>FC Max (Bpm)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{vo2}</td>
                          <td>{formatarNumero(((vo2 * peso) / 1000), 1)}</td>
                          <td>{formatarNumero((vo2 / 3.5), 1)}</td>
                          <td>-</td>
                        </tr>
                      </tbody>
                    </table>
                    <GraficoBarraComIndicador valor={distancia} faixas={faixasVO2calculadas} />
                    {encontrarFaixa(distancia, faixasVO2calculadas) && (
                    <div
                        className="resultado-classificacao"
                        style={{ border: `2px solid ${encontrarFaixa(distancia, faixasVO2calculadas)?.color}`, marginTop: 25}}>
                        <span>
                          Classificação: <strong>{encontrarFaixa(distancia, faixasVO2calculadas)?.name}</strong>
                        </span>
                      </div>
                    )}

                    <div className="resultado-referencia-vo2">
                      <p className='vo2-info-title'>Valores de referência</p>
                      <p className='vo2-info-sub-title'>Estimados por Idade e Gordura corporal</p>
                      <p className='vo2-info-content pad-top-10'>VO2 estimado: <span>{vo2Preditivo}</span> (mL/kg/min)</p>
                    </div>

                  </div>
                )}
                {(metodo === 'coconi' || metodo === 'astrand') &&(
                  <div className="resultado-vo2-container">
                    <table className="table-result-vo2">
                      <thead>
                        <tr>
                          <th>VO₂ Max (mL/kg/min)</th>
                          <th>VO₂ Max (L/min)</th>
                          <th>METs</th>
                          <th>FC Max (Bpm)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{vo2}</td>
                          <td>{formatarNumero(((vo2 * peso) / 1000), 1)}</td>
                          <td>{formatarNumero((vo2 / 3.5), 1)}</td>
                          <td>{fcmax}</td>
                        </tr>
                      </tbody>
                    </table>
                    <GraficoBarraComIndicador valor={vo2} faixas={faixasVO2calculadas} />
                    {encontrarFaixa(vo2, faixasVO2calculadas) && (
                    <div
                        className="resultado-classificacao"
                        style={{ border: `2px solid ${encontrarFaixa(vo2, faixasVO2calculadas)?.color}`, marginTop: 25}}>
                        <span>
                          Classificação: <strong>{encontrarFaixa(vo2, faixasVO2calculadas)?.name}</strong>
                        </span>
                      </div>
                    )}
                    <div className="resultado-limiares-vo2">
                      <p className='vo2-info-title'>Limiares ventilatórios</p>
                      <div className='limiar-container'>
                        <div className='limiar-container-left'>
                          <p>Limiar aeróbio (L1)</p>
                          <p>Velocidade: <span>{velocidadePrimeiroLimiar}</span></p>
                          <p>FC: <span>{fcPrimeiroLimiar}</span> bpm</p>
                          <p>% da FC de pico: <span>{fcPicoPrimeiroLimiarmax}</span>%</p>
                        </div>
                        <div className='limiar-container-right'>
                          <p>Limiar anaeróbio (L2)</p>
                          <p>Velocidade: <span>{velocidadeSegundoLimiar}</span></p>
                          <p>FC: <span>{fcSegundoLimiar}</span> bpm</p>
                          <p>% da FC de pico: <span>{fcPicoSegundoLimiarmax}</span>%</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {(metodo === 'ventilatorio') &&(
                  <div className="resultado-vo2-container">
                    <table className="table-result-vo2">
                      <thead>
                        <tr>
                          <th>VO₂ Max (mL/kg/min)</th>
                          <th>VO₂ Max (L/min)</th>
                          <th>METs</th>
                          <th>FC Max (Bpm)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{vo2}</td>
                          <td>{formatarNumero(((vo2 * peso) / 1000), 1)}</td>
                          <td>{formatarNumero((vo2 / 3.5), 1)}</td>
                          <td>{fcmax}</td>
                        </tr>
                      </tbody>
                    </table>
                    <GraficoBarraComIndicador valor={vo2} faixas={faixasVO2calculadas} />
                    {encontrarFaixa(vo2, faixasVO2calculadas) && (
                    <div
                        className="resultado-classificacao"
                        style={{ border: `2px solid ${encontrarFaixa(vo2, faixasVO2calculadas)?.color}`, marginTop: 25}}>
                        <span>
                          Classificação: <strong>{encontrarFaixa(vo2, faixasVO2calculadas)?.name}</strong>
                        </span>
                      </div>
                    )}

                    <div className="resultado-limiares-vo2" style={{width: 400}}>
                      <p className='vo2-info-title'>Velocidades dos limiares ventilatórios</p>
                      <div className='limiar-container'>
                        <div>
                          <p>Velocidade do limiar ventilatório 1 (VLV1): <span>{vlv1}</span> km/h</p>
                          <p>Velocidade do limiar ventilatório 2 (VLV2): <span>{vlv2}</span> km/h</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {(metodo === 'margaria') &&(
                  <div>
                    <text class="resultado-vo2">Potência anaeróbia: <b>{potencia}</b> (mL/kg/min)</text>
                  </div>
                )}
            </div>
          </div>
        )}

        <Modal
          isOpen={isNextModal}
          onRequestClose={closeNextModal}
          contentLabel="Confirmacao"
          className="modal-next"
          overlayClassName="popup-overlay"
          >
            <p className="popupNext-h1">VO2 máx finalizado!</p>
            <p className="popupNext-h2">Deseja ir para a Prescrição de Treino Aeróbico?</p>
            <div className="sub-pagination-buttons">
              <button className="next-prev-button" type="button" onClick={() => setActiveTab("PrescricaoTreinoAerobico")}>
                Sim
              </button>
              <button className="next-prev-button" type="button" onClick={closeNextModal}>
                Não
              </button>
            </div>
        </Modal>

        <div className="pagination-footer">
          <div className="sub-pagination-footer">
            <div className="sub-pagination-buttons">
              {etapa > 0 && (
                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                  Voltar
                </button>
              )}
              {etapa < 3 ? (
                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                  Avançar
                </button>
              ) : (
              <button className="next-prev-button" type="button" onClick={handleVo2Register}>Registrar</button>
              )}
            </div>
            <div className="progress-container">
              <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
            </div>
          </div>
          <div className="info-box-container" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
            <div className="info-button">
              <HelpCircle size={20} />
              Mais informações
            </div>
            {showInfo && (
              <div className="info-box-content">
                <p className="">
                  VO₂máx (consumo máximo de oxigênio) é a medida da capacidade máxima do organismo de captar, transportar e utilizar oxigênio durante o exercício físico, sendo um dos principais indicadores da aptidão cardiorrespiratória.
                  <br/><br/>
                  Sua avaliação permite estimar o nível de condicionamento físico, eficiência cardiovascular e resistência aeróbica, sendo amplamente utilizada para prescrição de treinamento, monitoramento de performance e avaliação de saúde.
                  <br/><br/>
                  Quanto maior o VO₂máx, maior tende a ser a capacidade do corpo de sustentar esforços prolongados com eficiência. Sua análise é essencial para individualizar treinos, acompanhar evolução e identificar o nível funcional do avaliado.
                </p>
              </div>
            )}
          </div>
        </div>

      </div>

    </div>
  );
}

export default Vo2;
